export default Object.freeze({
  A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: "Samanniminen asettelu on jo olemassa",
  ACCEPT: "Hyv\xE4ksy",
  ACCEPT_ALL: "Hyv\xE4ksy kaikki",
  ACCEPT_REJECT_TRANSFER_PENDING: "Hyv\xE4ksynt\xE4 odottaa",
  ACCEPTED: "Hyv\xE4ksytty",
  ACCOUNT: "Tili",
  ACCOUNT_ADDRESS: "Tilin osoite",
  ACCOUNT_COUNTRY: "Tilin maa",
  ACCOUNT_END: "Tilin loppu",
  ACCOUNT_NAME: "Tilin nimi",
  ACCOUNT_NUMBER: "Tilinumero",
  ACCOUNT_NUMBER_REQUIRED: "Tilin numero vaaditaan",
  ACCOUNTS: "Tilit",
  ACCUMULATED_DAYS_ON_RENT: "Kertyneet p\xE4iv\xE4t vuokralla",
  ACCUMULATED_DAYS_RENTED: "Kertyneet vuokrausp\xE4iv\xE4t",
  ACTIONS: "Toiminnot",
  ACTIVE_WARRANTY: "Aktiivinen takuu",
  ACTIVE_WARRANTY_CLICK_FOR_DETAIL: "Aktiivinen takuu (saat lis\xE4tietoja napsauttamalla)",
  ACTUAL_AUDIT: "Todellinen tarkastus",
  ACTUAL_AUDIT_DATE: "Todellinen kirjausp\xE4iv\xE4m\xE4\xE4r\xE4",
  ACTUAL_COURIER_NAME: "Todellinen kuriirin nimi",
  ACTUAL_HOURS: "Todelliset tunnit",
  ADD_CLAIM: "Lis\xE4\xE4 anomus",
  ADD_CLAIMS: "Lis\xE4\xE4 anomuksia",
  ADD_COMPONENT: "Lis\xE4\xE4 komponentti",
  ADD_OPTION: "Lis\xE4\xE4 asetus",
  ADD_REP: "Lis\xE4korjaus",
  ADD_TO_AUDIT: "Lis\xE4\xE4 valvontaan",
  ADDITIONAL: "Lis\xE4tiedot",
  ADDITIONAL_COMMENTS: "Lis\xE4kommentit",
  ADDITIONAL_REPAIR: "Lis\xE4korjaus",
  ADDITIVE: "Lis\xE4ys",
  ADDRESS: "Osoite",
  ADDRESS_LINE1: "Osoiterivi 1",
  ADDRESS_LINE1_REQUIRED: "Osoiterivi 1 vaaditaan",
  ADDRESS_LINE2: "Osoiterivi 2",
  ADJ_CLM: "S\xE4\xE4d\xE4 vaatimus",
  ADJUST_CLAIM: "Muokkaa anomusta",
  ADJUSTED_HOURS: "S\xE4\xE4detyt tunnit",
  ADJUSTED_QUANTITY: "Muokkaa anomusta",
  ADJUSTMENT_TYPE: "S\xE4\xE4t\xF6tyyppi",
  ADVANCED_CLAIM_SUMMARY: "Lis\xE4anomusyhteenveto",
  AFTER_DELIVERY_INSPECTION: "TOIMITUSTARKASTUKSEN J\xC4LKEEN",
  AGENCY_NAME: "Viraston nimi",
  ALL: "Kaikki",
  ALL_ACCOUNTS: "Kaikki tilit",
  ALL_CLAIMS: "Kaikki anomukset",
  ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: "Kaikki v\xE4itteet on tarkistettava (lis\xE4tietoja on JD WAM 110.08 -asiakirjassa)",
  ALL_CLAIMS_TAB: "Kaikki anomukset ({count, number})",
  ALL_PART_REQUESTS: "Kaikki osapyynn\xF6t",
  ALL_PART_REQUESTS_WITH_COUNT: "Kaikki osapyynn\xF6t ({count})",
  ALL_PARTS_RETURNED: "Kaikki osat palautettu",
  AMOUNT: "Summa",
  AMOUNT_1: "Summa 1",
  AMOUNT_2: "Summa 2",
  AMOUNT_3: "Summa 3",
  AMOUNT_OF_USE: "K\xE4ytt\xF6m\xE4\xE4r\xE4",
  AMOUNT_OF_USE_HISTORY_WITH_COUNT: "K\xE4ytt\xF6historian m\xE4\xE4r\xE4 ({count})",
  AMOUNT_OF_USE_IS_REQUIRED: "K\xE4ytt\xF6m\xE4\xE4r\xE4 on pakollinen",
  AMOUNT_OF_USE_REQUIRED: "K\xE4ytt\xF6m\xE4\xE4r\xE4 on pakollinen",
  AMOUNT_OF_USE_UNITS_REQUIRED: "Tarvittavien k\xE4ytt\xF6yksik\xF6iden m\xE4\xE4r\xE4",
  AMOUNT_RECORDED: "Tallennettu summa",
  AMOUNT_TO_BE_DEBITED: "Hyvitett\xE4v\xE4 summa",
  APLYPIP: "Lis\xE4\xE4 PIP-kampanjakoodi",
  APPLICATION: "Sovellus",
  APPLICATION_IS_REQUIRED: "Sovellus on pakollinen",
  APPLY: "Lis\xE4\xE4",
  APPLY_TRAVEL: "Lis\xE4\xE4 matkustus",
  APPROVAL_DEALER_COMMENTS: "Hyv\xE4ksynn\xE4n j\xE4lleenmyyj\xE4n kommentit",
  APPROVAL_DETAILS: "Hyv\xE4ksymistiedot",
  APPROVAL_LEVELS: "Hyv\xE4ksynt\xE4tasot",
  APPROVAL_REMARKS: "Hyv\xE4ksynt\xE4huomautukset",
  APPROVAL_STATUS: "Hyv\xE4ksynn\xE4n tila",
  APPROVE: "Hyv\xE4ksy",
  APPROVE_LABOR_RATE: "Hyv\xE4ksy Labor Rate",
  APPROVE_MACHINE_STATUS_UPDATE: "Hyv\xE4ksy koneen tilan p\xE4ivitys",
  APPROVE_PIP_CODE_REQUEST: "Hyv\xE4ksy PIP-koodipyynt\xF6",
  APPROVE_SPECIAL_ALLOWANCE_CLAIM: "Hyv\xE4ksy erikoiskorvausanomus",
  APPROVED: "Hyv\xE4ksytty",
  APPROVED_CORE_VALUE: "Hyv\xE4ksytty kuoripantti",
  APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: "Hyv\xE4ksytty p\xE4iv\xE4m\xE4\xE4r\xE4 ei voi olla ennen luontip\xE4iv\xE4\xE4",
  APPROVED_DIAGNOSTIC_AMOUNT: "Hyv\xE4ksytty diagnostiikan summa",
  APPROVED_DIAGNOSTIC_HOURS: "Hyv\xE4ksytyt diagnostiikkatunnit",
  APPROVED_IS_REQUIRED: "Hyv\xE4ksynt\xE4 on pakollinen",
  APPROVED_LABOR_ADDITIVE: "Hyv\xE4ksytty ty\xF6lis\xE4",
  APPROVED_LABOR_AMOUNT: "Hyv\xE4ksytty ty\xF6m\xE4\xE4r\xE4",
  APPROVED_LABOR_HOURS: "Hyv\xE4ksytyt ty\xF6tunnit",
  APPROVED_LABOR_TOTAL: "Hyv\xE4ksytty ty\xF6 yhteens\xE4",
  APPROVED_ON_SHELF_COST: "Hyv\xE4ksytty hyllytyksess\xE4",
  APPROVED_OTHER_CREDITS: "Hyv\xE4ksytyt muut hyvitykset",
  APPROVED_PARTS: "Hyv\xE4ksytyt osat",
  APPROVED_PARTS_ADDITIVE: "Hyv\xE4ksyttyjen osien lis\xE4",
  APPROVED_PARTS_TOTAL: "Hyv\xE4ksytyt osat yhteens\xE4",
  APPROVED_REJECTED: "Hyv\xE4ksytty/hyl\xE4tty",
  APPROVED_REPAIR_AMOUNT: "Hyv\xE4ksytty korjaussumma",
  APPROVED_REPAIR_HOURS: "Hyv\xE4ksytyt korjaustunnit",
  APPROVED_TAXES_TOTAL: "Hyv\xE4ksytyt verot yhteens\xE4",
  APPROVED_TRAVEL_TOTAL: "Hyv\xE4ksytyt matkakulut yhteens\xE4",
  APPROVER: "Hyv\xE4ksyj\xE4",
  ASCENDING: "Nouseva",
  ATTACHMENTS: "Liitteet",
  AUDIT_NUMBER: "Tilintarkastuksen numero",
  AUDIT_PLANNED: "Tarkastus suunniteltu",
  AUDIT_REQUIREMENT: "Tarkastusvaatimus",
  AUDIT_RESULTS: "Tarkastustulokset",
  AUDIT_STATUS: "Tarkastuksen tila",
  AUDIT_SUBMITTED_SUCCESSFULLY: "Tarkastus l\xE4hetetty onnistuneesti",
  AUDIT_SUMMARY: "Tarkastusyhteenveto",
  AUDIT_TYPE: "Tarkastustyyppi",
  AUDITS: "Tarkastukset",
  AUDITS_DUE_WITH_COUNT: "{countToDisplay} tarkistusta er\xE4\xE4ntyy",
  AUDITS_DUE_WITHIN_30_DAYS: "{countToDisplay} {count, monikko, yksi {Audit} muu {Audit}} er\xE4\xE4ntyy 30 p\xE4iv\xE4n kuluessa",
  AUDITS_PAST_DUE_WITH_COUNT: "{countToDisplay} {count, monikko, yksi {Audit} muu {audit} er\xE4\xE4ntynyt",
  AUTHORIZATION_NUMBER: "Varmennusnumero",
  AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: "L\xE4het\xE4 automaattisesti j\xE4lleenmyyj\xE4n liiketoimintaj\xE4rjestelm\xE4st\xE4",
  AVAILABLE: "K\xC4YTETT\xC4VISS\xC4",
  AVAILABLE_COLUMNS: "K\xE4ytett\xE4viss\xE4 olevat sarakkeet",
  AVERAGE_DIAGNOSTICS_HOURS: "Keskim\xE4\xE4r\xE4iset diagnostiikkatunnit",
  AVERAGE_LUG_HEIGHT: "Keskim\xE4\xE4r\xE4inen lavankorkeus",
  AVERAGE_LUG_HEIGHT_IS_REQUIRED: "Keskim\xE4\xE4r\xE4inen lavan korkeus vaaditaan",
  AVERAGE_REPAIR_HOURS: "Keskim\xE4\xE4r\xE4iset korjaustunnit",
  AVERAGE_REPLACEMENT_HOURS: "Keskim\xE4\xE4r\xE4iset vaihtotunnit",
  AVERAGE_TECH_PAY_RATE: "Keskim\xE4\xE4r\xE4inen tekninen palkkio",
  BACK: "Takaisin",
  BACK_TO_AUDIT: "Takaisin tarkastukseen",
  BASE_MACHINE: "Peruskone",
  BASE_MACHINE_IMPLEMENTS: "Koneen perusty\xF6koneet",
  BASE_MACHINE_PIN: "Koneen PIN-koodi",
  BASIC_WARRANTY_ENDS: "Perustakuun p\xE4\xE4t",
  BASIC_WARRANTY_ESTIMATOR: "Perustakuun arviointi",
  BASIC_WARRANTY_STARTS: "Perustakuu alkaa",
  BASIS_FOR_SETTLEMENT: "Korvauksen peruste",
  BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: "Korvauksen peruste / Tarkastuksen kommenttien perusteet",
  BASIS_FOR_SETTLEMENT_IS_REQUIRED: "Korvauksen peruste on pakollinen tieto",
  BATTERY: "Akku",
  BEGIN_DATE: "Alkamisp\xE4iv\xE4m\xE4\xE4r\xE4",
  BRANCH: "Haara",
  BUILT: "Sis\xE4inen",
  BUSINESS_END: "Liiketoiminnan loppu",
  CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: "Voiko koneen palauttaa k\xE4ytt\xF6\xF6n?",
  CANCEL: "Peruuta",
  CERTIFIED_LETTER_SENT: "Sertifioitu kirje l\xE4hetetty",
  CGST: "CGST",
  CHANGE_RESPONSIBLE_DEALER: "Vaihda vastuullinen j\xE4lleenmyyj\xE4",
  CHANGE_STATUS: "Muuta tilaa",
  CHANGE_STATUS_FOR: "Muuta {pin} tilaa",
  CHANGED: "Muutettu",
  CHANGED_BY: "Muuttanut",
  CHANGED_ON: "Muutettu",
  CHINESE: "kiina",
  CITY: "Kaupunki",
  CITY_REQUIRED: "Paikkakunta vaaditaan",
  CLAIM: "Anomus",
  CLAIM_COUNT_WITH_PARENTHESIS: "({countToDisplay} {count, plural, one {Anomus} other {Anomusta}})",
  CLAIM_DEBIT: "Anomuksen debet",
  CLAIM_DETAILS: "Anomuksen tiedot",
  CLAIM_DRAFT: "Luonnos",
  CLAIM_HISTORY: "24 kuukauden takuuanomushistoria",
  CLAIM_HISTORY_WITH_COUNT: "24 kuukauden takuuhistoria ({count})",
  CLAIM_NUMBER: "Anomuksen numero",
  CLAIM_RECOVER_PERCENTAGE: "({%} %)",
  CLAIM_SEARCH: "Anomushaku",
  CLAIM_STATUS: "Anomuksen tila",
  CLAIM_TYPE: "Anomuksen tyyppi",
  CLAIM_TYPES: "Anomustyypit",
  CLAIM_UPDATED_SUCCESSFULLY: "Anomuksen p\xE4ivitys onnistui",
  CLAIM_VALUE: "Anomuksen arvo",
  CLAIM_VALUE_DETAILS: "Anomuksen arvon tiedot",
  CLAIM_WITH_NUMBER: "Anomus {claimNumber}",
  CLAIMS: "Anomukset",
  CLAIMS_IN_PROGRESS: "Meneill\xE4\xE4n olevat anomukset",
  CLAIMS_IN_PROGRESS_WITH_COUNT: "V\xE4itteet k\xE4ynniss\xE4 ({count})",
  CLAIMS_OVERVIEW: "Anomusten yleiskuvaus",
  CLAIMS_OVERVIEW_TAB: "Anomusten yleiskatsaus ({count})",
  CLAIMS_WITH_COUNT: "{count} v\xE4itett\xE4",
  CLICK_FOR_DETAILS: "(Katso lis\xE4tietoja napsauttamalla)",
  CLICK_TO_VIEW_ALL: "N\xE4yt\xE4 kaikki napsauttamalla",
  CLOSE: "Sulje",
  CLOSED_PART_REQUESTS: "Suljetut osapyynn\xF6t",
  CLOSING: "Sulkeminen",
  CLOSING_ACCOUNT: "Suljetaan tili",
  CLOSING_ACCOUNT_WITH_COUNT: "Suljetaan tili\xE4 ({count})",
  CODE: "Koodi",
  COLLAPSE_ALL: "Tiivist\xE4 kaikki",
  COMMENT: "Kommentti",
  COMMENTS: "Kommentit",
  COMMENTS_IS_REQUIRED: "Kommentit ovat pakollisia",
  COMMENTS_TO_DEALER: "J\xE4lleenmyyj\xE4n kommentit",
  COMMON_LABOR_TYPES_WARNING: "Kaikki ty\xF6tyypit eiv\xE4t ole k\xE4ytett\xE4viss\xE4 valituille tileille",
  COMPANY: "Yritys",
  COMPANY_CONTRIBUTION: "Yrityksen osuus",
  COMPANY_CONTRIBUTION_IS_REQUIRED: "Yrityksen osuus on pakollinen",
  COMPLAINT_CAUSE: "Mik\xE4 oli valituksen syy?",
  COMPLAINT_CAUSE_IS_REQUIRED: "Valituksen syy on pakollinen",
  COMPLAINT_CORRECTION: "Miten valitus korjattiin?",
  COMPLAINT_CORRECTION_IS_REQUIRED: "Valituskorjaus on pakollinen",
  COMPLETE: "Valmis",
  COMPLETED: "Valmis",
  COMPLETED_BY: "Suorittanut",
  COMPLETED_DATE: "Valmistumisp\xE4iv\xE4m\xE4\xE4r\xE4",
  COMPLETED_IN_LAST_24_MONTHS: "Valmis viimeisten 24 kuukauden aikana",
  COMPLETION_STATUS: "Valmistumisen tila",
  COMPONENT: "Komponentti",
  COMPONENT_CODE: "Komponenttikoodi",
  COMPONENT_CREATED_SUCCESSFULLY: "Komponentin luominen onnistui",
  COMPONENT_DELETED_SUCCESSFULLY: "Komponentin poisto onnistui",
  COMPONENT_SERIAL_NUMBER: "Komponentin sarjanumero",
  COMPONENT_SUCCESSFULLY_UPDATED: "Komponentin p\xE4ivitys onnistui",
  COMPONENTS: "Osat",
  CONFIRM: "Vahvista",
  CONFIRM_ADDITIONAL_REPAIR: "Haluatko varmasti lis\xE4t\xE4 lis\xE4korjauksen?",
  CONFIRM_ADJUST_CLAIM: "Haluatko varmasti muokata t\xE4t\xE4 anomusta?",
  CONFIRM_CLOSING_ACCOUNT: "Haluatko varmasti hyv\xE4ksy\xE4 t\xE4m\xE4n siirron?",
  CONFIRM_COPY_CLAIM: "Haluatko varmasti kopioida t\xE4m\xE4n anomuksen?",
  CONFIRM_DELETE_ATTACHMENT: "Haluatko varmasti poistaa t\xE4m\xE4n liitteen?",
  CONFIRM_DELETE_CLAIM: "Haluatko varmasti poistaa t\xE4m\xE4n anomuksen?",
  CONFIRM_DELETE_REGISTRATION: "Haluatko varmasti poistaa t\xE4m\xE4n rekister\xF6innin?",
  CONFIRM_EDIT_CLAIM: "Haluatko varmasti muokata t\xE4t\xE4 anomusta?",
  CONFIRM_RECONCILE_CLAIM: "Haluatko varmasti t\xE4sm\xE4ytt\xE4\xE4 t\xE4m\xE4n anomuksen?",
  CONFIRM_RESEND_XML: "Haluatko varmasti l\xE4hett\xE4\xE4 XML:n uudelleen? Odota 24-48 tuntia, jotta se n\xE4kyy.",
  CONFIRM_SKIP_AUDIT: "Haluatko varmasti ohittaa t\xE4m\xE4n tarkistuksen?",
  CONFIRM_UNDO_REGISTRATION: "Haluatko varmasti kumota t\xE4m\xE4n rekister\xF6innin?",
  CONTACTED: "Yhteyshenkil\xF6",
  CONTAINS: "Sis\xE4lt\xE4\xE4",
  CONTRACT_NUMBER: "Sopimusnumero",
  CONTRACT_PURCHASED: "Ostettu sopimus",
  CONTRACT_TYPE: "Sopimustyyppi",
  COPY_CLAIM: "Kopioi anomus",
  CORE: "Ydin",
  CORE_VALUE: "Ydinarvo",
  COUNTRY: "Maa",
  COUNTRY_REQUIRED: "Maa pakollinen",
  COURIER_ACCOUNT_NUMBER: "Kuriiritilin numero",
  COURIER_NAME: "Kuriirin nimi",
  COVERAGE_DECISION: "Kattavuusp\xE4\xE4t\xF6s",
  COVERAGE_TYPE: "Kattavuustyyppi",
  CRDMEM: "Hyvityslasku",
  CREATE: "Luo",
  CREATE_CLAIM: "Luo anomus",
  CREATE_LAYOUT: "Luo asettelu",
  CREATE_NON_TRACKED_PIN_HELP_TEXT: "Ennen kuin voit tehd\xE4 anomuksen t\xE4st\xE4 tuotteesta, sinun on ilmoitettava meille siit\xE4 t\xE4rkeit\xE4 tietoja",
  CREATE_PIP_CLAIM: "Luo PIP-anomus",
  CREATE_PIP_CLAIMS: "Luo PIP-anomukset",
  CREATE_PRODUCT_RECORD: "Luo tuotetietue",
  CREATE_REQUEST: "Luo pyynt\xF6",
  CREATE_TRANSFER_PENDING: "Siirto odottaa",
  CREATE_TRANSFER_SERVICE_UNAVAILABLE: "Luo siirtopalvelu ei ole k\xE4ytett\xE4viss\xE4",
  CREATED: "Luotu",
  CREATED_BY: "Luonut",
  CREATED_DATE: "Luontip\xE4iv\xE4m\xE4\xE4r\xE4",
  CREATED_ON: "Luotu",
  CREATION_DATE: "Luontip\xE4iv\xE4m\xE4\xE4r\xE4",
  CREDIT_MEMO: "Hyvityslasku",
  CREDIT_MEMO_DATE: "Hyvityslaskun p\xE4iv\xE4m\xE4\xE4r\xE4",
  CREDIT_MEMO_ISSUE_DATE: "My\xF6nnetty hyvityslasku",
  CREDIT_MEMO_NUMBER: "Hyvityslaskun numero",
  CREDIT_MEMO_PROCESS_DATE: "Hyvityslasku k\xE4sitelty",
  CREDIT_MEMO_SELECTED: "Hyvityslasku valittu",
  CREDIT_MEMOS: "Hyvityslaskut",
  CRITERIA: "Kriteerit",
  CRT: "Luo",
  CSV_SEPARATOR: "CSV-erotin",
  CURRENCY: "Valuutta",
  CURRENT: "Nykyinen",
  CURRENT_ACCOUNT: "Nykyinen tili",
  CURRENT_AMOUNT_OF_USE: "Nykyinen k\xE4ytt\xF6m\xE4\xE4r\xE4",
  CURRENT_CUSTOMER: "Nykyinen asiakas",
  CURRENT_DEALER: "Nykyinen j\xE4lleenmyyj\xE4",
  CURRENT_DEALER_DISTANCE: "Nykyinen j\xE4lleenmyyj\xE4n et\xE4isyys",
  CURRENT_DEALER_LAST_SERVICE_DATE: "Nykyinen j\xE4lleenmyyj\xE4n viimeinen huoltop\xE4iv\xE4m\xE4\xE4r\xE4",
  CURRENT_DEALER_LOCATION: "Nykyinen j\xE4lleenmyyj\xE4n sijainti",
  CURRENT_HOURS: "Nykyiset tunnit",
  CURRENT_QUANTITY: "Aktuell kvantitet",
  CURRENT_RESPONSIBLE_DEALER: "Nykyinen vastuullinen j\xE4lleenmyyj\xE4",
  CURRENT_VALUES: "Nykyiset arvot",
  CURRENTLY_ON_RENT: "T\xE4ll\xE4 hetkell\xE4 vuokralla",
  CUSTOM_RANGE: "Mukautettu alue",
  CUSTOM_VALUES: "Mukautetut arvot",
  CUSTOMER: "Asiakas",
  CUSTOMER_CONTRIBUTION: "Asiakkaan osuus",
  CUSTOMER_CONTRIBUTION_IS_REQUIRED: "Asiakkaan osallistuminen on pakollinen",
  CUSTOMER_CREATED_SUCCESSFULLY: "Asiakkaan luonti onnistui",
  CUSTOMER_DETAILS: "Asiakkaan tiedot",
  CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: "Asiakkaan tietojen p\xE4ivitt\xE4minen onnistui",
  CUSTOMER_INFORMATION: "Asiakkaan tiedot",
  CUSTOMER_INFORMATION_IS_REQUIRED: "Asiakastiedot ovat pakollisia.",
  CUSTOMER_INVALID: "Asiakasta ei l\xF6ytynyt tai luotu. Etsi asiakas",
  CUSTOMER_NAME: "Asiakkaan nimi",
  CUSTOMER_NAME_IS_REQUIRED: "Asiakkaan nimi on pakollinen.",
  CUSTOMER_NOT_FOUND: "Asiakasta ei l\xF6ydy",
  CUSTOMER_REQUIRED: "Asiakas vaaditaan",
  CUSTOMER_RESOLUTION: "Asiakkaan ratkaisu",
  CUSTOMER_RESOLUTION_IS_REQUIRED: "Asiakkaan ratkaisu vaaditaan",
  CUSTOMER_SEARCH: "Asiakashaku",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Asiakkaan p\xE4ivitys onnistui",
  DAMAGED_MACHINES_HELP_TEXT: "Vaurioituneiden koneiden takuu keskeytet\xE4\xE4n automaattisesti, kunnes TCSM tarkistaa t\xE4m\xE4n lomakkeen ja hyv\xE4ksyy sen, jotta takuu voidaan palauttaa. Vaurioituneisiin koneisiin voidaan soveltaa vain pakollisia ja turvaohjeita.",
  DATE: "P\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_FORMAT: "P\xE4iv\xE4m\xE4\xE4r\xE4n muoto",
  DATE_ISSUED: "My\xF6nt\xE4misp\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_OF_CERTIFIED_LETTER: "Sertifioidun kirjeen p\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_OF_EVENT_CAUSING_DAMAGE: "Vahingon aiheuttaneen tapahtuman p\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_OF_LAST_PERSONAL_CONTACT: "Edellisen henkil\xF6kohtaisen yhteystiedon p\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_RECALLED_PART_WAS_SHIPPED_SENT: "Peruutetun osan l\xE4hetyksen/l\xE4hetyksen p\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_REFUSED: "Hylk\xE4\xE4misp\xE4iv\xE4m\xE4\xE4r\xE4",
  DATE_SUBMITTED: "L\xE4hetysp\xE4iv\xE4",
  DAYS_FROM_REGISTRATION: "P\xE4iv\xE4\xE4 rekister\xF6innist\xE4",
  DAYS_LEFT: "P\xE4ivi\xE4 j\xE4ljell\xE4",
  DAYS_LEFT_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} Left",
  DAYS_ON_RENT: "Vuokrausp\xE4iv\xE4t",
  DAYS_REMAINING: "P\xE4ivi\xE4 j\xE4ljell\xE4",
  DAYS_REMAINING_WITH_COUNT: "{daysToDisplay} {days, plural, one {Day} other {Days}} j\xE4ljell\xE4",
  DAYS_TO_DISPLAY: "N\xE4ytett\xE4v\xE4t p\xE4iv\xE4t",
  DBS: "DBS",
  DEALER: "J\xE4lleenmyyj\xE4",
  DEALER_ACCOUNT: "J\xE4lleenmyyj\xE4n tili",
  DEALER_ACCOUNT_IS_REQUIRED: "J\xE4lleenmyyj\xE4n tili on pakollinen",
  DEALER_ACCOUNTS: "J\xE4lleenmyyj\xE4n tilit",
  DEALER_CITY: "J\xE4lleenmyyj\xE4n paikkakunta",
  DEALER_COMMENTS: "J\xE4lleenmyyj\xE4n kommentit",
  DEALER_CONTRIBUTION: "J\xE4lleenmyyj\xE4n osuus",
  DEALER_CONTRIBUTION_IS_REQUIRED: "J\xE4lleenmyyj\xE4n osuus on pakollinen",
  DEALER_HIERARCHY_ACCOUNT: "{account} ({IndustryIndicator})",
  DEALER_INVOICE_NUMBER: "J\xE4lleenmyyj\xE4n laskun numero",
  DEALER_INVOICE_UPDATED: "J\xE4lleenmyyj\xE4n lasku p\xE4ivitetty",
  DEALER_INVOICE_UPDATES: "J\xE4lleenmyyj\xE4n lasku",
  DEALER_INVOICES: "J\xE4lleenmyyj\xE4n laskut",
  DEALER_LOCATION: "J\xE4lleenmyyj\xE4n sijainti",
  DEALER_LOCATION_FILTER: "Suodattimen sijainnit",
  DEALER_LOCATION_IS_REQUIRED: "J\xE4lleenmyyj\xE4n sijainti on pakollinen",
  DEALER_LOCATIONS: "J\xE4lleenmyyj\xE4n sijainnit",
  DEALER_NAME: "J\xE4lleenmyyj\xE4n nimi",
  DEALER_PHONE: "J\xE4lleenmyyj\xE4n puhelinnumero",
  DEALER_POSTAL_CODE: "J\xE4lleenmyyj\xE4n postinumero",
  DEALER_RECOMMENDATIONS: "J\xE4lleenmyyj\xE4n suositukset",
  DEALER_RECOMMENDATIONS_TAB: "J\xE4lleenmyyj\xE4n suositukset ({count})",
  DEALER_REVIEW_REQUEST_SUCCESSFULLY: "J\xE4lleenmyyj\xE4n uudelleentarkastelu onnistui",
  DEALER_SEARCH: "J\xE4lleenmyyj\xE4haku",
  DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: "Kirjoita j\xE4lleenmyyjien hakuun k\xE4ytett\xE4v\xE4 nimi, paikkakunta tai tili",
  DEALER_STATE: "J\xE4lleenmyyj\xE4n tila",
  DEALER_SUBMISSION_WITH_CURRENCY: "J\xE4lleenmyyj\xE4n l\xE4hetys ({valuutta})",
  DEALER_TRANSFER_HISTORY: "J\xE4lleenmyyj\xE4n siirtohistoria",
  DEALER_TRANSFER_REQUEST_SUCCESSFULLY: "J\xE4lleenmyyj\xE4n siirtopyynn\xF6n Jonotus Onnistui",
  DEALER_WARRANTY: "J\xE4lleenmyyj\xE4n takuu",
  DEALERS: "J\xE4lleenmyyj\xE4t",
  DEALERSHIP: "J\xE4lleenmyyj\xE4",
  DEBIT: "Debet",
  DEBIT_AMOUNT: "Veloitussumma",
  DEBIT_FOR_CLAIM_NUMBER: "Veloitus: {claimNumber}",
  DEBIT_REQUIRED: "Veloitus vaaditaan",
  DEBIT_REQUIRED_STATUS: "Veloituksen pakollinen tila",
  DEBIT_SUBMITTED_SUCCESSFULLY: "Debet l\xE4hetetty onnistuneesti",
  DEBIT_TYPE: "Veloitustyyppi",
  DEBITED: "Hyvitetty",
  DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: "T\xE4h\xE4n vaatimukseen liittyv\xE4t veloitukset on suoritettava manuaalisessa veloitusprosessissa",
  DECIMAL_FORMAT: "Desimaalimuoto",
  DECISION_UPDATED: "P\xE4\xE4t\xF6s p\xE4ivitetty",
  DECLINE: "Hylk\xE4\xE4",
  DEDUCTIBLE: "V\xE4hennett\xE4v\xE4",
  DEERE_REMARKS: "Deeren huomautukset",
  DEFAULT_WARRANTY: "Oletustakuu",
  DEL: "Poista",
  DELETE: "Poista",
  DELETE_ATTACHMENT: "Poista liite",
  DELETE_CLAIM: "Poista anomus",
  DELETE_REGISTRATION: "Poista rekister\xF6inti",
  DELETE_REGISTRATION_SUCCESS: "Rekister\xF6innin poisto onnistui",
  DELETED: "Poistettu",
  DELETED_BY: "Poistaja",
  DELIVERED: "Toimitettu",
  DELIVERED_IS_REQUIRED: "Toimitustieto on pakollinen",
  DELIVERY_DATE: "Toimitusp\xE4iv\xE4m\xE4\xE4r\xE4",
  DELIVERY_DATE_REQUIRED: "Toimitusp\xE4iv\xE4m\xE4\xE4r\xE4 vaaditaan",
  DELIVERY_DATES: "Toimitusp\xE4iv\xE4m\xE4\xE4r\xE4t",
  DELIVERY_NO_DOCUMENTS: "Toimitus, ei asiakirjoja",
  DEMO_RENTAL_BEGIN_DATE: "Esittelyn/vuokrauksen aloitusp\xE4iv\xE4m\xE4\xE4r\xE4",
  DEMO_RENTAL_CHOOSE_DEALERS_STATUS: "Valitse j\xE4lleenmyyj\xE4t ja tila",
  DEMO_RENTAL_END_DATE: "Esittelyn/vuokrauksen p\xE4\xE4ttymisp\xE4iv\xE4",
  DEMO_RENTAL_HISTORY: "Esittelykoneen vuokrahistoria",
  DENY: "Est\xE4",
  DENY_MACHINE_STATUS_UPDATE: "Est\xE4 koneen tilan p\xE4ivitys",
  DENY_PIP_CODE_REQUEST: "Est\xE4 PIP-koodipyynt\xF6",
  DESCENDING: "Laskeva",
  DESCRIPTION: "Kuvaus",
  DESCRIPTION_OF_DAMAGE: "Vahingon kuvaus",
  DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: "Vahingon aiheuttavan tapahtuman kuvaus",
  DESELECT_ALL: "Poista kaikkien valinta",
  DETAILS: "Tiedot",
  DIAGNOSTICS_COVERED: "Diagnostiikka k\xE4yt\xF6ss\xE4",
  DIS_VSR: "N\xE4yt\xE4 viestit",
  DISPLAY: "N\xE4ytt\xF6",
  DISPLAY_CLAIM: "N\xE4yt\xE4 anomus",
  DISPLAY_CREDIT_MEMO: "N\xE4yt\xE4 hyvityslasku",
  DISPLAY_FORMAT: "N\xE4ytt\xF6muoto",
  DISPLAY_PRODUCT: "N\xE4yt\xE4 tuote",
  DISPLAY_TAG: "N\xE4ytt\xF6tunniste",
  DISTANCE: "Et\xE4isyys",
  DISTANCE_FROM_CURRENT_DEALER: "Et\xE4isyys nykyisest\xE4 j\xE4lleenmyyj\xE4st\xE4",
  DISTANCE_FROM_POTENTIAL_DEALER: "Et\xE4isyys potentiaalisesta j\xE4lleenmyyj\xE4st\xE4",
  DIVISION: "Divisioona",
  DIVISION_SUMMARY: "Jakoyhteenveto",
  DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: "Haluatko tallentaa muutokset?",
  DOES_NOT_CONTAIN: "Ei sis\xE4ll\xE4",
  DOWNLOAD_TO_EXCEL: "Lataa Exceliin",
  DOWNTIME: "K\xE4ytt\xF6katkokset",
  DOWNTIME_IS_REQUIRED: "K\xE4ytt\xE4m\xE4tt\xF6myysaika on pakollinen",
  DRAFT: "Tallenna luonnoksena",
  DTAC_CASE: "DTAC-tapaus",
  DTAC_CASE_NUMBER: "DTAC-tapauksen numero",
  DTAC_SOLUTION: "DTAC-ratkaisu",
  DUE_DATE: "M\xE4\xE4r\xE4p\xE4iv\xE4",
  DUE_WITHIN_3_MONTHS: "M\xE4\xE4r\xE4p\xE4iv\xE4 3 kuukauden kuluessa",
  DUPLICATE_PIN_PLATE: "PIN-kyltin monistaminen",
  DUPLICATE_PIN_PLATE_REQUEST_UPDATED: "PIN-kyltin kaksoiskappalepyynt\xF6 p\xE4ivitetty",
  DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: "PIN-kyltin kaksoiskappalepyynn\xF6n luominen onnistui",
  DUPLICATE_PIN_PLATE_WITH_COUNT: "PIN-kylttipyynn\xF6n kaksoiskappale ({count})",
  EDIT: "Muokkaa",
  EDIT_CUSTOMER: "Muokkaa asiakasta",
  EDIT_LAYOUT: "Muokkaa asettelua",
  EDIT_WITH_PARENTHESES: "(Muokkaa)",
  EFFECTIVE: "Voimassa",
  EFFECTIVE_DATE: "Voimaantulop\xE4iv\xE4",
  EMAIL: "S\xE4hk\xF6posti",
  EMISSIONS_PART_SEARCH: "P\xE4\xE4st\xF6osien haku",
  END_DATE: "P\xE4\xE4ttymisp\xE4iv\xE4",
  END_USE: "Loppuk\xE4ytt\xF6",
  END_USE_CODE: "Loppuk\xE4ytt\xF6koodi",
  END_USE_CODE_REQUIRED: "Loppuk\xE4ytt\xF6koodi vaaditaan",
  ENDS_WITH: "P\xE4\xE4ttyy",
  ENGLISH: "englanti",
  ENTER_A_NUMBER_BETWEEN_0_AND_1000: "Anna luku v\xE4lilt\xE4 0 - 1 000",
  ENTER_A_NUMBER_BETWEEN_0_AND_10000: "Anna luku v\xE4lilt\xE4 0 - 10000",
  ENTER_A_NUMBER_FROM_1_TO_9999: "Anna luku 1 - 9 9 999",
  ENTER_A_PART_NUMBER: "Anna osanumero",
  ENTER_COMMENTS_BEFORE_ACCEPTING: "Kirjoita kommentit ennen hyv\xE4ksymist\xE4",
  EQUALS: "Yht\xE4 suuri kuin",
  ERROR: "VIRHE:",
  ERROR_MESSAGE_TITLE: "Tapahtui virhe:",
  ERROR_MESSAGES: "Virhesanomat",
  ERROR_MESSAGES_TITLE: "On tapahtunut useita virheit\xE4:",
  ERROR_NETWORK_ISSUES: "Verkkovirhe esti joidenkin tietojen lataamisen - yrit\xE4 uudelleen",
  ERROR_NO_DATA_TO_EXPORT: "Ei viet\xE4vi\xE4 tietoja",
  ERROR_RETRIEVING_CUSTOMER_INFORMATION: "Virhe noudettaessa asiakastietoja",
  ERROR_SAP: "Yhteyden muodostaminen palvelimeen ei onnistu.  Jos ongelma ei poistu, pyyd\xE4 apua ongelman ratkaisemiseen Ota yhteytt\xE4 -linkin avulla.",
  ERROR_SESSION: "Istuntosi on vanhentunut.  Kirjaudu takaisin sis\xE4\xE4n p\xE4ivitt\xE4m\xE4ll\xE4 sivu.",
  ERROR_UNHANDLED: "J\xE4rjestelm\xE4 havaitsi odottamattoman virheen.  Jos ongelma ei poistu, pyyd\xE4 apua ongelman ratkaisemiseen k\xE4ytt\xE4m\xE4ll\xE4 Ohje-toimintoa tai Ota yhteytt\xE4 -linkki\xE4.",
  ERROR_UPLOADING_FILE: "Tiedostoa ei lis\xE4tty",
  ESTIMATED_BASIC_DATE: "Arvioitu perusp\xE4iv\xE4m\xE4\xE4r\xE4",
  ESTIMATED_BASIC_DAYS: "Arvioidut perusp\xE4iv\xE4t",
  ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: "Arviot eiv\xE4t v\xE4ltt\xE4m\xE4tt\xE4 vastaa esittelytilaa tai tunteja, joita ei ole viel\xE4 ilmoitettu",
  EXCEEDS_DEMO_THRESHOLD: "Ylitt\xE4\xE4 esittelyrajan",
  EXCHANGE_RATE: "Vaihtokurssi",
  EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: "Ohitetut PIN-koodit eiv\xE4t sis\xE4lly t\xE4h\xE4n raporttiin.",
  EXECUTE: "Suorita",
  EXPAND_ALL: "Laajenna kaikki",
  EXPECTED_FIRST_USE: "Odotettu ensimm\xE4inen k\xE4ytt\xF6",
  EXPIRATION_DATE: "Vanhentumisp\xE4iv\xE4",
  EXPIRED: "Vanhentunut",
  EXPIRED_PART_REQUESTS: "Vanhentuneet varaosapyynn\xF6t",
  EXPIRED_PIPS: "Vanhentuneet PIP-ohjelmat",
  EXPIRES: "Vanhenee",
  EXPIRING_SOON: "Vanhenee pian",
  EXPORT: "Vie",
  EXTENDED_WARRANTY: "Laajennettu takuu",
  FACTORY: "TEHDAS",
  FACTORY_NAME: "Tehtaan nimi",
  FAILED: "Ep\xE4onnistui",
  FAILED_AREA: "Ep\xE4onnistunut alue",
  FAILED_AREA_IS_REQUIRED: "Ep\xE4onnistunut alue on pakollinen",
  FAILED_DATE: "Ep\xE4onnistumisp\xE4iv\xE4m\xE4\xE4r\xE4",
  FAILED_DATE_IS_REQUIRED: "Ep\xE4onnistumisp\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  FAILED_MODE: "Ep\xE4onnistunut tila",
  FAILED_MODE_COMMENTS: "Ep\xE4onnistuneen tilan kommentit",
  FAILED_PART: "Ep\xE4onnistunut osa",
  FAILED_PART_DESCRIPTION: "Ep\xE4onnistuneen osan kuvaus",
  FAILED_PART_IS_A_REMAN_PART: "Ep\xE4onnistunut osa on ReMan-osa",
  FAILED_PART_IS_REQUIRED: "Ep\xE4onnistunut osa vaaditaan",
  FAILED_PART_SERIAL: "Ep\xE4onnistuneen osan sarja",
  FAILED_PART_SERIAL_IS_REQUIRED: "Ep\xE4onnistuneen osan sarja vaaditaan",
  FAILURE_DATE: "Virheen p\xE4iv\xE4m\xE4\xE4r\xE4",
  FAILURE_INFORMATION: "Virhetiedot",
  FAILURE_MODE: "Vikatila",
  FAILURE_MODE_IS_REQUIRED: "Ep\xE4onnistui-tila on pakollinen",
  FAILURE_PART: "Ep\xE4onnistunut osa",
  FAILURE_PART_DESCRIPTION: "Vian osan kuvaus",
  FAILURE_PART_IS_REQUIRED: "Vika-osa vaaditaan",
  FAILURE_TO_RETURN_PARTS_WARNING: "Jos pyydettyj\xE4 osia ei palauteta, seurauksena voi olla veloitus.",
  FAVORITES: "Suosikit",
  FILE_NAME: "Tiedoston nimi",
  FILE_SIZE_IS_TOO_BIG: "Tiedoston koko on liian suuri (enimm\xE4iskoko: 100 Mt)",
  FILE_SIZE_IS_TOO_BIG_CSV: "Tiedoston koko on liian suuri (enimm\xE4iskoko: 1 Mt)",
  FILE_UPLOAD_MESSAGE: "Pudota tiedostot t\xE4h\xE4n tai lis\xE4\xE4 tiedostoja napsauttamalla (Enimm\xE4iskoko: 100 Mt)",
  FILE_UPLOAD_MESSAGE_CSV: "Pudota tiedostot t\xE4h\xE4n tai lis\xE4\xE4 tiedostoja napsauttamalla (Enimm\xE4iskoko: 1 Mt)",
  FILE_UPLOAD_MESSAGE_IMAGE: "Ved\xE4 ja pudota kuvia t\xE4h\xE4n tai napsauta t\xE4t\xE4, kun haluat lis\xE4t\xE4 kuvia (enimm\xE4iskoko: 100 Mt).",
  FILE_UPLOAD_MESSAGE_SINGLE: "Pudota yksi tiedosto t\xE4h\xE4n tai napsauta kohtaa Lis\xE4\xE4 (Enimm\xE4iskoko: 100 Mt)",
  FILE_UPLOAD_UNABLE_TO_READ: "J\xE4rjestelm\xE4 ei voinut lukea tiedostoasi.  Vertaa sit\xE4 malliin ja yrit\xE4 uudelleen.",
  FILES: "Tiedostot",
  FILTER_PLACEHOLDER: "Suodata tulokset",
  FILTER_WITH_ELLIPSIS: "Suodata...",
  FILTERED_BY_COLUMN_ID: "Suodatettu: {ColumnId}",
  FIND_CUSTOMER: "Etsi asiakas",
  FINNISH: "Suomi",
  FIRST_MAINTENANCE: "ENSIMM\xC4INEN HUOLTO",
  FIRST_NAME: "Etunimi",
  FIRST_NAME_IS_REQUIRED: "Etunimi on pakollinen",
  FIRST_SHIP_TO_LOCATION: "Ensimm\xE4inen toimituspaikka",
  FIRST_USE: "Ensimm\xE4inen k\xE4ytt\xF6",
  FISCAL_YEAR: "Tilikausi",
  FLUID_SAMPLING_REQUIRED: "Nesten\xE4yte vaaditaan",
  FORWARDED: "V\xE4litetty",
  FRENCH: "ranska",
  FROM: "L\xE4hett\xE4j\xE4",
  FRWRD: "Eteenp\xE4in",
  FULL_DEBIT: "T\xE4ysi debet",
  GENERAL: "Yleist\xE4",
  GERMAN: "saksa",
  GET_MAINTENANCE_PLANS: "Hae huoltosuunnitelmat",
  GOODS_INSTALLATION_VAT: "Tavaroiden asennuksen ALV",
  GRACE_PERIOD: "Grace period",
  GREATER_THAN: "Suurempi kuin",
  GREATER_THAN_OR_EQUALS: "Suurempi tai yht\xE4 suuri kuin",
  GROUP_COMPLETE: "Ryhm\xE4 valmis",
  GST_PERCENTAGE: "GST-prosentti",
  HISTORY_TO_DISPLAY: "N\xE4ytett\xE4v\xE4 historia (p\xE4iv\xE4\xE4)",
  HOME: "Aloitussivu",
  HOUR_LIMIT: "Tuntiraja",
  HOURS: "Tunnit",
  HOURS_ON_RENT: "Tunteja vuokrassa",
  HSN_SAC_CODE: "HSN/SAC-koodi",
  IGST: "IGST",
  IMPLEMENTS: "Ty\xF6koneet",
  IN_RANGE: "Alueella",
  INCENTIVE: "Kannustin",
  INCENTIVE_PROGRAMS: "Kannustinohjelmat",
  INCLUDE_FULLY_COMPLETE: "Sis\xE4llyt\xE4 t\xE4ysin valmiit PIP-ohjelmat",
  INDICATES_REQUIRED_FIELD: "Ilmaisee pakollisen kent\xE4n",
  INFO_MESSAGE_TITLE: "J\xE4rjestelm\xE4ilmoitus l\xE4hetettiin:",
  INFO_MESSAGES: "Tietosanomat",
  INFO_MESSAGES_TITLE: "Useita j\xE4rjestelm\xE4ilmoituksia on l\xE4hetetty:",
  INFO_REQUEST_STATUS_ERROR: "Tiedot voidaan l\xE4hett\xE4\xE4 t\xE4m\xE4n pyynn\xF6n kanssa.",
  INFORMATION: "Tiedot",
  INFORMATION_REQUEST: "Tietopyynt\xF6",
  INFORMATION_REQUEST_STATUS: "Tietopyynn\xF6n tila",
  INPUT_PIN: "PIN-koodi",
  INSPECTION: "Tarkastus",
  INSTALLED_BY: "Asentaja",
  INSTALLED_BY_IS_REQUIRED: "Asentajatieto on pakollinen",
  INTERNAL_DEERE_COMMENTS: "Deeren sis\xE4iset kommentit",
  INTERVAL_BEGINS: "Aikav\xE4li alkaa",
  INTERVAL_ENDS: "Aikav\xE4lin loppu",
  INTERVAL_TYPE_DESCRIPTION: "Aikav\xE4lin tyypin kuvaus",
  INVOICE_ACCOUNT: "Laskutustili",
  INVOICE_DEALER: "Laskun j\xE4lleenmyyj\xE4",
  INVOICE_NUMBER: "Laskun numero",
  INVOICE_REQUEST: "Laskutuspyynt\xF6",
  INVOICE_SENT: "Lasku l\xE4hetetty",
  INVOICE_UPDATED_SUCCESSFULLY: "Laskun p\xE4ivitys onnistui",
  INVOICED: "Laskutettu",
  INVOICED_TO: "Laskutettu",
  IRC_PIN_MESSAGE: "Asiakkaalla on oikeus ilmaiseen matkustusaikaan ja matkaan ensimm\xE4isten 500 tunnin tai 12 kuukauden ajan koneen omistajuudesta.",
  ISSUED: "My\xF6nnetty",
  ITALIAN: "italia",
  ITEM: "Kohde",
  ITEM_NUMBER: "Nimikkeen numero",
  ITEM_NUMBER_IS_REQUIRED: "Nimikenumero on pakollinen",
  JDLINK_EXPIRES: "JDLink vanhenee",
  JDP_COMMENTS: "JDP-kommentit",
  JDP_COMMENTS_IS_REQUIRED: "JDP-kommentit ovat pakollisia",
  JDP_CUSTOMER_RESOLUTION: "JDP-asiakasratkaisu",
  JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: "JDP-asiakasratkaisu vaaditaan",
  JDP_REASON: "JDP-syy",
  JDP_REASON_IS_REQUIRED: "JDP-syy on pakollinen",
  LABOR: "Ty\xF6",
  LABOR_ADDITIVE: "Ty\xF6lis\xE4",
  LABOR_ADDITIVE_COMPLETION_DETAIL: "Ty\xF6n lis\xE4n valmistumistiedot",
  LABOR_ADDITIVE_PIPS: "Ty\xF6lis\xE4n PIP-ohjelmat",
  LABOR_ADDITIVE_TAB: "Lis\xE4 ({count})",
  LABOR_ADJUSTMENT: "Ty\xF6n mukauttaminen",
  LABOR_COMMENTS: "Ty\xF6kommentit",
  LABOR_HOURS: "Ty\xF6tunnit",
  LABOR_ITEM_DETAILS: "Ty\xF6 - {m\xE4\xE4r\xE4} {yksikk\xF6} {kuvaus}",
  LABOR_RATE_APPROVED_SUCCESSFULLY: "Ty\xF6voimaprosentti hyv\xE4ksytty onnistuneesti",
  LABOR_RATE_CHANGE_SUBMITTED: "Ty\xF6m\xE4\xE4r\xE4n muutos l\xE4hetetty",
  LABOR_RATE_CHANGES_WITH_COUNT: "Ty\xF6m\xE4\xE4r\xE4n muutokset ({count})",
  LABOR_RATE_CONFIRM: "Pyydetty nopeus on pienempi kuin nykyinen nopeus.  Haluatko varmasti l\xE4hett\xE4\xE4 pyynn\xF6n?",
  LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: "Punaisella tekstill\xE4 ilmaisevat, ett\xE4 korotus on yli 10 % nykyisest\xE4 tasosta",
  LABOR_RATE_HISTORY: "Ty\xF6hinnan historia",
  LABOR_RATE_REJECTED_SUCCESSFULLY: "Ty\xF6voimaprosentti hyl\xE4tty",
  LABOR_RATE_REQUESTS_STATUS: "Ty\xF6m\xE4\xE4r\xE4pyynt\xF6jen tila",
  LABOR_RATE_RETURNED_SUCCESSFULLY: "Ty\xF6voimaprosentti palautettu",
  LABOR_RATES: "Ty\xF6voimahinnat",
  LABOR_STATS: "Ty\xF6tilastot",
  LABOR_TOTAL: "Ty\xF6 yhteens\xE4",
  LABOR_TYPE: "Ty\xF6n tyyppi",
  LABOR_VALUE: "Ty\xF6n arvo",
  LABOR_WITH_COUNT: "Ty\xF6 ({count})",
  LANGUAGE: "Kieli",
  LAST_LOCATION_FROM: "Viimeinen sijainti kohteesta",
  LAST_NAME: "Sukunimi",
  LAST_NAME_IS_REQUIRED: "Sukunimi on pakollinen",
  LAST_PERSONAL_CONTACT: "Viimeinen henkil\xF6kohtainen yhteyshenkil\xF6",
  LAW_ENFORCEMENT_AGENCY_DETAILS: "Lainvalvontaviraston tiedot",
  LAYOUT_CREATED_SUCCESSFULLY: "Asettelun luominen onnistui",
  LAYOUT_DELETED_SUCCESSFULLY: "Asettelu poistettu",
  LAYOUT_NAME: "Asettelun nimi",
  LAYOUT_UPDATED_SUCCESSFULLY: "Asettelun p\xE4ivitys onnistui",
  LEAD_ACCOUNT: "Liiditili",
  LEAD_DEALER: "Liidin j\xE4lleenmyyj\xE4",
  LESS_THAN: "Alle",
  LESS_THAN_OR_EQUALS: "Pienempi tai yht\xE4 suuri kuin",
  LICENSE_PLATE_NUMBER: "Rekisterikilven numero",
  LIFETIME: "K\xE4ytt\xF6ik\xE4",
  LINE_ITEMS_EXPORT: "Rivinimikkeiden vienti",
  LIST: "Luettelo",
  LIST_TOTAL: "Luettelo yhteens\xE4",
  LOCATION: "Sijainti",
  LOCATION_DUE: "Sijainnin m\xE4\xE4r\xE4aika",
  LOCATIONS: "Sijainnit",
  LOCATIONS_WITH_COUNT: "Sijainnit ({count})",
  MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: "Kone on jo rekister\xF6ity t\xE4lle asiakkaalle",
  MACHINE_INFORMATION: "Koneen tiedot",
  MACHINE_MODEL_TYPE: "Koneen malli/tyyppi",
  MACHINE_MODEL_TYPE_REQUIRED: "Koneen malli/tyyppi vaaditaan",
  MACHINE_STATUS: "Koneen tila",
  MACHINE_STATUS_UPDATE_ACCEPTED: "Koneen tilan p\xE4ivitys hyv\xE4ksytty",
  MACHINE_STATUS_UPDATE_DOCUMENT: "Koneen tilan p\xE4ivitysasiakirja",
  MACHINE_STATUS_UPDATE_REJECTED: "Koneen tilan p\xE4ivitys hyl\xE4tty",
  MACHINE_STATUS_UPDATES_WITH_COUNT: "Koneen tilan p\xE4ivitykset ({count})",
  MACHINE_TYPE: "Koneen tyyppi",
  MACHINE_TYPE_IS_REQUIRED: "Konetyyppi vaaditaan",
  MACHINE_USE: "Koneen k\xE4ytt\xF6",
  MAILING_RECIPIENT: "Postituksen vastaanottaja (etu- ja sukunimi)",
  MAILING_RECIPIENT_REQUIRED: "Postituksen vastaanottaja vaaditaan",
  MAINTENANCE: "Huolto",
  MAINTENANCE_PLAN: "Huoltosuunnitelmat",
  MAINTENANCE_PLAN_INFO: "Huoltosuunnitelman tiedot",
  MARK_AS_REVIEW: "Merkitse tarkistetuksi",
  MARKETING_INCENTIVE: "Markkinointi - kannustava",
  MARKETING_JD_PROMISE: "Markkinointi - JD-lupaus",
  MARKETING_MAINTENANCE_PLAN: "Markkinointi - Huoltosuunnitelma",
  MARKETING_MASS_CHANNEL_FOLLOWUP: "Markkinointi - massakanavan seuranta",
  MARKETING_MASS_CHANNEL_PDI: "Markkinointi - Massakanava-PDI",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP: "Massakanavaasiakkaan seuranta",
  MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: "Muistutus - varmista, ett\xE4 otat yhteytt\xE4 omaan oikeusavustajaasi m\xE4\xE4ritt\xE4\xE4ksesi asianmukaiset #Do Not Call# -menettelyt osavaltiossa ja liittovaltiotasolla ennen kuin toteutat jatkotoimet myyntipuhelun j\xE4lkeen -ohjelman j\xE4lkeen",
  MASS_CHANNEL_PDI_CLAIM: "Massakanavan PDI",
  MASTER_WARRANTY_TYPE: "P\xE4\xE4takuun tyyppi",
  MATERIAL: "Materiaalin numero",
  MERCHANDISE: "Kauppa",
  MESSAGE: "Viesti",
  MESSAGES: "Viestit",
  METHOD_OF_CONTACT: "Yhteystapa",
  METHOD_OF_CONTACT_IS_REQUIRED: "Yhteystapa on pakollinen",
  METRIC: "Metrinen",
  METRICS: "Mittarit",
  MILEAGE_LIMIT: "Kilometrien raja",
  MOBILE_PHONE: "Matkapuhelin",
  MODEL: "Malli",
  MODEL_NUMBER: "Mallin numero",
  MODIFIED: "Muokattu",
  MONTH_TO_DATE: "Kuukauden alusta",
  MORE: "Enemm\xE4n",
  MULTIPLE: "Useita",
  NAME: "Nimi",
  NET: "Netto",
  NET_AMOUNT: "Nettom\xE4\xE4r\xE4",
  NET_AMOUNT_PAID: "Maksettu nettom\xE4\xE4r\xE4",
  NET_TOTAL: "Netto yhteens\xE4",
  NEW: "Uusi",
  NEW_ACCOUNT: "Uusi tili",
  NEW_CLAIM: "Uusi anomus",
  NEW_CLAIM_VALUE: "Uusi vaatimusarvo",
  NEW_CUSTOMER_REQUIRED: "Uusi asiakas vaaditaan",
  NEW_DEALER: "Uusi j\xE4lleenmyyj\xE4",
  NEW_DEALER_DISTANCE: "Uusi j\xE4lleenmyyj\xE4n et\xE4isyys",
  NEW_DEALER_LOCATION: "Uusi j\xE4lleenmyyj\xE4n sijainti",
  NEW_LABOR_RATE: "Uusi ty\xF6m\xE4\xE4r\xE4",
  NEW_REQUEST_ENTER_RATES: "Uusi pyynt\xF6 - Sy\xF6t\xE4 nopeudet",
  NEW_STATUS: "Uusi tila",
  NEW_TRANSFER: "Uusi siirto",
  NEW_TRANSFER_CREATED: "Uusi siirto luotu",
  NEW_VALUE: "Uusi arvo",
  NO: "EI",
  NO_ACTIVE_WARRANTY: "Ei aktiivista takuuta",
  NO_AFFECTED_PINS: "J\xE4lleenmyyj\xE4si vastuulla ei ole PIN-koodeja, joihin ongelma vaikuttaa",
  NO_AUTHORITY_TO_ACCESS: "Sinulla ei ole oikeuksia k\xE4ytt\xE4\xE4 JDWS-j\xE4rjestelm\xE4\xE4. J\xE4lleenmyyj\xE4n k\xE4ytt\xE4j\xE4t voivat tarkistaa j\xE4rjestelm\xE4nvalvojan (DPA) tiedot ja ottaa yhteytt\xE4 tukeen ja saada kopion t\xE4st\xE4 virheest\xE4",
  NO_CLAIMS: "Anomuksia ei ole.",
  NO_CUSTOMER_ASSOCIATED: "Asiakasta ei ole liitetty",
  NO_CUSTOMER_SELECTED: "Asiakasta ei ole valittu",
  NO_DEALER_INVOICES: "Ei j\xE4lleenmyyj\xE4n laskuja",
  NO_DEALERS_MAPPED: "K\xE4ytt\xE4j\xE4tunnukseesi ei ole m\xE4\xE4ritetty j\xE4lleenmyyji\xE4. Ota yhteytt\xE4 j\xE4rjestelm\xE4nvalvojaan.",
  NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: "Ei (Jos ei, kuva on esitett\xE4v\xE4 todisteena)",
  NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: "Tietoja ei ole saatavilla t\xE4lle tuotteelle",
  NO_LOWERCASE: "Ei",
  NO_MATCHING_DEALERS: "Ei vastaavaa j\xE4lleenmyyj\xE4\xE4.",
  NO_OPEN_PART_REQUESTS: "Ei avoimia varaosapyynt\xF6j\xE4",
  NO_OPEN_PIPS: "Ei avoimia PIP-ohjelmia",
  NO_PARTS_RETURNED: "Ei palautettuja osia",
  NO_PIP_PRODUCTS: "PIP-tuotteita ei ole.",
  NO_PRODUCT_FOUND: "Tuotetta ei l\xF6ytynyt",
  NO_REQUIRED_ITEMS: "Pakollisia kohteita ei ole.",
  NO_RESULTS: "Ei tuloksia",
  NO_RESULTS_FOUND: "Tuloksia ei l\xF6ytynyt",
  NO_ROWS_TO_SHOW: "Ei n\xE4ytett\xE4vi\xE4 rivej\xE4",
  NO_SPECIAL_INSTRUCTIONS: "Ei erityisohjeita.",
  NO_TRAVEL: "Ei matkustus",
  NON_RECOVERABLE_TAXES: "Ei-palautettavat verot",
  NON_TRACKED_PINS_HELP_TEXT: "Jotkin tuotteet n\xE4kyv\xE4t takuutilassa vasta rekister\xF6innin j\xE4lkeen. Haku vastaa useita n\xE4it\xE4 tuotteita.",
  NON_TRAVEL: "Ei ajo",
  NONE: "Ei mit\xE4\xE4n",
  NORMAL: "NORMAALI",
  NOT_EQUAL: "Erisuuri",
  NOTIFICATION_ADDED_SUCCESSFULLY: "Ilmoituksen lis\xE4\xE4minen onnistui",
  NOTIFICATION_DELETED_SUCCESSFULLY: "Ilmoituksen poistaminen onnistui",
  NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: "Ilmoitusj\xE4rjestyksen p\xE4ivitys onnistui",
  NOTIFICATION_UPDATED_SUCCESSFULLY: "Ilmoituksen p\xE4ivitys onnistui",
  NOTIFICATIONS: "Ilmoitukset",
  NUMBER_OF_DIAGNOSTICS_OCCURRENCES: "Diagnostiikkatapahtumien m\xE4\xE4r\xE4",
  NUMBER_OF_OPEN_PIPS: "{number} avointa PIP-osoitetta",
  NUMBER_OF_REPAIR_OCCURRENCES: "Korjauskertojen m\xE4\xE4r\xE4",
  NUMBER_OF_REPLACEMENT_OCCURRENCES: "Vaihtomerkkien m\xE4\xE4r\xE4",
  OLD_LABOR_RATE: "Vanha labor rate",
  ON_SHELF: "Hyllyss\xE4",
  ON_SHELF_COST: "Hyllyss\xE4 kusatnnus",
  ONE_ITEM_MUST_BE_SELECTED: "Yksi kohde on valittava",
  OPEN: "Avaa",
  OPEN_PART_REQUESTS: "Avaa osapyynn\xF6t",
  OPEN_PART_REQUESTS_WITH_COUNT: "Avaa osapyynn\xF6t ({count})",
  OPEN_PIP_COUNT: "Avaa PIP-m\xE4\xE4r\xE4",
  OPEN_PIP_PROGRAMS: "PIP-rekisteri",
  OPEN_PIPS: "Avoimet PIP-ohjelmat",
  OPEN_PIPS_REPORT: "Avointen PIP-raportti",
  OPEN_PIPS_TAB: "Avaa PIP-ohjelmat ({count})",
  OPERATORS_COMPLAINT: "Mik\xE4 oli k\xE4ytt\xE4j\xE4n valitus?",
  OPERATORS_COMPLAINT_IS_REQUIRED: "K\xE4ytt\xE4j\xE4n valitus vaaditaan",
  OPERATORS_MANUAL_NUMBER: "K\xE4ytt\xF6ohjeen numero",
  OPTION_CODE: "Varustekoodi",
  OPTION_CODE_CREATED_SUCCESSFULLY: "Asetuskoodi luotu onnistuneesti",
  OPTION_CODE_DELETED_SUCCESSFULLY: "Asetuskoodi poistettiin onnistuneesti",
  OPTION_CODES: "Varustekoodit",
  OR: "tai",
  ORIGINAL_CLAIM_VALUE: "Alkuper\xE4inen takuuhakemuksen arvo",
  ORIGINAL_SUBMISSION_DATE: "Alkuper\xE4inen l\xE4hetysp\xE4iv\xE4m\xE4\xE4r\xE4",
  ORIGINALLY_SUBMITTED: "Alkuper\xE4inen l\xE4hetetty",
  OTHER: "Muut",
  OTHER_AMOUNT_OF_USE: "Muu k\xE4ytt\xF6m\xE4\xE4r\xE4",
  OTHER_AMOUNT_OF_USE_REQUIRED: "Muu tarvittava k\xE4ytt\xF6m\xE4\xE4r\xE4",
  OTHER_CREDIT: "Muu hyvitys",
  OTHER_CREDIT_1: "Muu hyvitys 1",
  OTHER_CREDIT_2: "Muu hyvitys 2",
  OTHER_CREDIT_3: "Muu hyvitys 3",
  OTHER_CREDIT_ADJUSTMENT: "Muu hyvitysoikaisu",
  OTHER_CREDIT_ITEM_DETAILS: "Muu hyvitys - {description} ({count} {unit})",
  OTHER_CREDIT_TOTAL: "Muut hyvitykset yhteens\xE4",
  OTHER_CREDITS: "Muut hyvitykset",
  OTHER_CREDITS_WITH_COUNT: "Muut hyvitykset ({count})",
  OTHER_INSTRUCTIONS: "Muut ohjeet",
  OUTPUT_PIN: "Tulostuksen PIN",
  OVERDUE: "Er\xE4\xE4ntynyt",
  OVERRIDE_ACCOUNT: "Ohita tili",
  OVERRIDE_EFFECTIVE_DATE: "Ohita voimaantulop\xE4iv\xE4",
  OVERRIDE_SUGGESTED_ACCOUNT: "Ohita ehdotettu tili",
  OWNERSHIP_STATUS: "Omistajan tila",
  OWNERSHIP_STATUS_IS_REQUIRED: "Omistajan tila on pakollinen",
  PART: "Osa",
  PART_1: "Osa 1",
  PART_2: "Osa 2",
  PART_3: "Osa 3",
  PART_4: "Osa 4",
  PART_5: "Osa 5",
  PART_6: "Osa 6",
  PART_7: "Osa 7",
  PART_8: "Osa 8",
  PART_9: "Osa 9",
  PART_10: "Osa 10",
  PART_AMONT_OF_USE: "Osan k\xE4ytt\xF6m\xE4\xE4r\xE4",
  PART_FAMILY: "Osanimi",
  PART_ITEM_DETAILS: "Osat - {m\xE4\xE4r\xE4} {kuvaus} (varaosanumero {partNumber})",
  PART_NUMBER: "Varaosanumero",
  PART_REQUEST: "Varaosapyynt\xF6",
  PART_REQUEST_NUMBER: "Varaosapyynt\xF6 {rgaNumber}",
  PART_REQUEST_STATUS: "Varaosapyynn\xF6n tila",
  PART_REQUESTS: "Varaosapyynn\xF6t",
  PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: "Anna anomuksen numero, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: "anomushaussa on oltava v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: "DTAC-tapauksen numeron haun on oltava t\xE4ydellinen DTAC-tapausnumero, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: "Anna DTAC-tapauksen koko numero",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: "Osanumerohaussa on oltava v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: "Anna osanumero, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: "Varaosapyynn\xF6n numeron haussa on oltava v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: "Anna varaosapyynn\xF6n numero, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_PIN_ERROR: "PIN-haun on oltava v\xE4hint\xE4\xE4n 4 merkki\xE4 pitk\xE4",
  PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: "Anna PIN-koodi, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: "Ty\xF6tilaushaun on oltava t\xE4ysi ty\xF6tilaus, v\xE4hint\xE4\xE4n kaksi merkki\xE4",
  PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: "Anna t\xE4ysi ty\xF6tilaus",
  PART_REQUESTS_UPDATED_SUCCESSFULLY: "Varaosapyynn\xF6n p\xE4ivitys onnistui",
  PART_RETURN: "Varaosan palautus",
  PART_RETURNS: "Varaosien palautukset",
  PART_SERIAL_NUMBER: "Osan sarjanumero",
  PART_SERIAL_NUMBER_IS_REQUIRED: "Osan sarjanumero vaaditaan",
  PART_TOTAL: "Osa yhteens\xE4",
  PART_TYPE: "Varaosanumero",
  PART_USE: "Osan k\xE4ytt\xF6",
  PART_VALUE: "Osan arvo",
  PARTIAL_DEBIT: "Osittainen debet",
  PARTICIPANT: "Osallistuja",
  PARTS: "Osat",
  PARTS_ADDITIVE: "Osalis\xE4",
  PARTS_ADJUSTMENT: "Osien s\xE4\xE4t\xF6",
  PARTS_COVERAGE_SEARCH: "Osien peittohaku",
  PARTS_TEMPLATE: "Osien malli",
  PARTS_USE: "Osien k\xE4ytt\xF6",
  PARTS_USE_IS_REQUIRED: "Osien k\xE4ytt\xF6 on pakollista",
  PARTS_WITH_COUNT: "Osat ({count})",
  PARTS_WITH_PARENTHESES: "Osa(t)",
  PAST_DUE: "Er\xE4\xE4ntynyt",
  PAYER_ACCOUNT: "Maksajan tili",
  PERCENT_COMPLETE: "Prosenttia valmiina",
  PERCENTAGE: "Prosenttiosuus",
  PERCENTAGE_DEBIT: "Debet-prosentti",
  PERCENTAGE_SYMBOL: "{prosentti}",
  PERCENTAGE_TO_DEBIT: "Veloitusprosentti",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES: "Pysyv\xE4sti poissa k\xE4yt\xF6st\xE4 olevat koneet",
  PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: "Jos koneita ei k\xE4ytet\xE4 pysyv\xE4sti, lis\xE4\xE4 koneen kuva varmistaaksesi, ettei konetta voi rakentaa uudelleen, korjata tai k\xE4ytt\xE4\xE4 miss\xE4\xE4n vaiheessa tulevaisuudessa. Jatkuvasti poissa k\xE4yt\xF6st\xE4 olevat koneet eiv\xE4t ole oikeutettuja PIP-ohjelmiin.",
  PERSON_RESPONSIBLE: "Vastuuhenkil\xF6",
  PHONE: "Puhelin",
  PHONE_REQUIRED: "Puhelin vaaditaan",
  PICTURE: "Kuva",
  PICTURE_REQUEST: "Kuvapyynt\xF6",
  PICTURE_REQUEST_STATUS: "Kuvapyynn\xF6n tila",
  PICTURE_REQUEST_STATUS_ERROR: "Liitteet voidaan l\xE4hett\xE4\xE4 t\xE4m\xE4n pyynn\xF6n mukana.",
  PIN: "PIN",
  PIN_CREATED_SUCCESSFULLY: "PIN-koodin luonti onnistui",
  PIN_CROSS_REFERENCE: "PIN-tunnuksen ristiviittaus",
  PIN_INVALID: "PIN virheellinen",
  PIN_IS_REQUIRED: "Tappi vaaditaan",
  PIN_REQUIRED: "PIN vaaditaan",
  PIN_SEARCH: "Kiinnit\xE4 haku",
  PIN_SEARCH_INFORMATION: "Kiinnit\xE4 hakutiedot",
  PIN_TRANSFER_INFORMATION: "Pin-siirtotiedot",
  PINS: "PIN-koodit",
  PINS_NOT_REGISTERED: "PIN-koodeja ei ole rekister\xF6ity",
  PIP: "PIP",
  PIP_CODE: "PIP-koodi",
  PIP_CODE_CREATED_SUCCESSFULLY: "PIP-koodipyynn\xF6n luonti onnistui",
  PIP_CODE_REQUEST: "PIP-koodipyynt\xF6",
  PIP_CODE_REQUEST_APPROVED: "PIP-koodipyynt\xF6 hyv\xE4ksytty",
  PIP_CODE_REQUEST_REJECTED: "PIP-koodipyynt\xF6 hyl\xE4tty",
  PIP_CODE_REQUESTS_WITH_COUNT: "PIP-koodipyynn\xF6t ({count})",
  PIP_COMPLETION_STATUS: "PIP:n valmistumisen tila",
  PIP_DETAILS: "PIP-tiedot",
  PIP_HISTORY: "PIP-historia",
  PIP_ID: "PIP-numero",
  PIP_NUMBER: "PIP-numero",
  PIP_PROGRAM: "PIP-ohjelma",
  PIP_PROGRAM_IS_REQUIRED: "PIP-ohjelma vaaditaan",
  PIP_PROGRAMS: "PIP-ohjelmat",
  PIP_SEARCH: "PIP-haku",
  PIP_STATUS: "PIP-tila",
  PIP_TYPE: "PIP-tyyppi",
  PIP_TYPES: "PIP-tyypit",
  PIPS: "PIP-ohjelmat",
  PIPS_UNPAID_LABOR_ADDITIVE: "PIP-ohjelmien palkaton ty\xF6lis\xE4",
  PLAN_DESCRIPTION: "Suunnitelman kuvaus",
  PLAN_END_DATE: "Suunnitelman p\xE4\xE4ttymisp\xE4iv\xE4",
  PLAN_ENDS: "Suunnitelman loppu",
  PLAN_NAME: "Suunnitelman nimi",
  PLAN_NAME_IS_REQUIRED: "Suunnitelman nimi vaaditaan",
  PLAN_NAMES: "Suunnitelman nimet",
  PLAN_START_DATE: "Suunnitelman alkamisp\xE4iv\xE4m\xE4\xE4r\xE4",
  PLAN_STARTS: "Suunnitelma alkaa",
  PLANNED_BY: "Suunnitellut",
  PLANT: "Kasvi",
  PLATE_REQUEST_INFORMATION: "Kilven pyynt\xF6tiedot",
  PLEASE_SELECT_A_LEAD_ACCOUNT: "Valitse liiditili",
  PLEASE_SELECT_CLAIM_TYPE: "Valitse v\xE4itetyyppi",
  POLISH: "puola",
  PORTUGUESE: "portugali",
  POSTAGE_DELIVERY_DATE: "Postittajan toimitusp\xE4iv\xE4",
  POSTAL_CODE: "Postinumero",
  POSTAL_CODE_REQUIRED: "Postinumero vaaditaan",
  POSTAL_TRACKING_NUMBER: "Postituksen seurantanumero",
  POTENTIAL_RESPONSIBLE_DEALER: "Mahdollinen vastuullinen j\xE4lleenmyyj\xE4",
  PRE_DELIVERY_INSPECTION: "Luovutustarkastus",
  PREFERRED_THEME: "Ensisijainen teema",
  PREPARE_AUDIT: "Valmistele tarkastus",
  PREPARED: "Valmisteltu",
  PREPARING_AUDIT_FOR_WITH_DEALER: "Valmistellaan {dealer}-tarkistusta",
  PREVIOUS_AMOUNT_OF_USE: "Edellinen k\xE4ytt\xF6m\xE4\xE4r\xE4",
  PREVIOUS_INVOICE_NUMBER: "Edellinen laskun numero",
  PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: "Edellinen laskun numero on pakollinen",
  PREVIOUS_MONTH: "Edellinen kuukausi",
  PRICE: "Hinta",
  PRICING_SUMMARY: "Hinnoitteluyhteenveto",
  PRIMARY_ACTION: "Ensisijainen toiminto",
  PRIMARY_LANGUAGE: "Ensisijainen kieli",
  PRINT: "Tulosta",
  PRINT_CLAIM: "Tulosta anomus",
  PRINT_REGISTRATION_FORM: "Tulosta rekister\xF6intilomake",
  PRINT_REGISTRATION_FORM_MESSAGE: "Tuote rekister\xF6ity ensimm\xE4iselle omistajalle. Haluatko tulostaa rekister\xF6intilomakkeen nyt?",
  PRINT_TO_PDF: "Tulosta PDF-tiedostoon",
  PRIORITY: "Prioriteetti",
  PRNT_CLM: "N\xE4yt\xE4 anomus",
  PROCESS_DATE: "Prosessin p\xE4iv\xE4m\xE4\xE4r\xE4",
  PROCESSED: "K\xE4sitelty",
  PROCESSED_PART_REQUESTS: "K\xE4sitellyt osapyynn\xF6t",
  PROCESSING_STATUS: "K\xE4sittelyn tila",
  PROCESSING_STATUS_DESCRIPTION: "K\xE4sittelyn tilan kuvaus",
  PRODUCT_DETAILS: "Tuotteen tiedot",
  PRODUCT_HIERARCHY: "Tuotehierarkia",
  PRODUCT_INFORMATION: "Tuotetiedot",
  PRODUCT_REGISTERED: "Tuote rekister\xF6ity",
  PRODUCT_REGISTRATION: "Tuotteen rekister\xF6inti",
  PRODUCT_REGISTRATION_PENDED: "Tuotteen rekister\xF6inti on keskeytetty",
  PRODUCT_TRACKING: "Tuoteseuranta",
  PRODUCTS: "Tuotteet",
  PRODUCTS_BY_CUSTOMER: "Tuotteet asiakkaan mukaan",
  PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: "Hakutuloksista saattaa puuttua aiempia PIN-koodeja tilap\xE4isen j\xE4rjestelm\xE4n yhteysongelman vuoksi",
  PRODUCTS_WITH_COUNT: "Tuotteet ({count})",
  PROGRAM: "Ohjelma",
  PROGRAM_DESCRIPTION: "Ohjelman kuvaus",
  PROGRAM_IS_REQUIRED: "Ohjelma on pakollinen.",
  PROGRAM_NAME: "Ohjelman nimi",
  PROGRAM_NUMBER: "Ohjelman numero",
  PRT: "PRT",
  PRTS: "PRT:t",
  PURCHASE_INFO: "Ostotiedot",
  PURCHASE_ORDER: "Ostotilaus",
  PURCHASE_ORDER_IS_REQUIRED: "Ostotilaus on pakollinen",
  PURCHASER_TYPE: "Ostajan tyyppi",
  PURCHASER_TYPE_REQUIRED: "Ostajan tyyppi vaaditaan",
  PUSH_XML: "L\xE4het\xE4 XML uudelleen",
  QTY: "M\xE4\xE4r\xE4",
  QUALIFY_FOR_EMISSIONS: "P\xE4\xE4st\xF6t",
  QUANTITY: "M\xE4\xE4r\xE4",
  QUANTITY_1: "M\xE4\xE4r\xE4 1",
  QUANTITY_2: "M\xE4\xE4r\xE4 2",
  QUANTITY_3: "M\xE4\xE4r\xE4 3",
  QUANTITY_4: "M\xE4\xE4r\xE4 4",
  QUANTITY_5: "M\xE4\xE4r\xE4 5",
  QUANTITY_6: "M\xE4\xE4r\xE4 6",
  QUANTITY_7: "M\xE4\xE4r\xE4 7",
  QUANTITY_8: "M\xE4\xE4r\xE4 8",
  QUANTITY_9: "M\xE4\xE4r\xE4 9",
  QUANTITY_10: "M\xE4\xE4r\xE4 10",
  QUERY_MUST_CONTAIN_3_CHARACTERS: "Kyselyss\xE4 on oltava v\xE4hint\xE4\xE4n kolme merkki\xE4",
  QUEST_DESC: "Kyselt\xE4v\xE4 kuvaus",
  QUESTIONABLE_PART: "Kyselt\xE4v\xE4 osa",
  QUEUED: "Jonossa",
  REASON_FOR_CHANGE: "Muutoksen syy",
  REASON_FOR_DEBIT: "Veloituksen syy",
  REASON_FOR_MISSING_PLATE: "Puuttuvan levyn syy",
  REASON_FOR_MISSING_PLATE_REQUIRED: "Puuttuvan levyn syy",
  REASON_FOR_OVERRIDE: "Ohituksen syy",
  REASON_FOR_REFUSAL: "Kielt\xE4ytymisen syy",
  REASON_FOR_RETURN: "Palautuksen syy",
  REASON_FOR_RETURN_IS_REQUIRED: "Palautuksen syy on pakollinen",
  REASON_FOR_TRANSFER: "Siirron syy",
  REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: "Siirron syyss\xE4 on oltava aakkosnumeerisia merkkej\xE4",
  RECIPIENT_DEALER_OR_TCSM: "Vastaanottaja(j\xE4lleenmyyj\xE4 tai TCSM)",
  RECIPIENT_MAILING: "Postituksen vastaanottaja",
  RECONCILE: "T\xE4sm\xE4yt\xE4",
  RECONCILE_CLAIM: "T\xE4sm\xE4yt\xE4 anomus",
  RECONCILED: "T\xE4sm\xE4ytetty",
  RECORD_AUDIT: "Tietueen seuranta",
  RECORD_AUDIT_FOR: "Tietueen seuranta: {dealer}",
  RECORDS_FOUND: "{countToDisplay} {count, monikko, l\xF6ytyi yksi {record} muu {record}} muu",
  RECOVERABLE_TAXES: "Palautettavat verot",
  RECOVERED: "Palautettu",
  RECOVERED_WITH_MISSED_ADDITIVES: "Palautettu puuttuvilla lis\xE4illa",
  RECOVERED_WITHOUT_ADDITIVES: "Peritty ilman lisi\xE4",
  RECOVERY: "Palautus",
  RED_MUST_BE_LESS_THAN_YELLOW: "Punaisen Merkkivalon Arvon On Oltava Pienempi Kuin Keltainen Ilmaisin",
  REFERENCE_1: "Viite 1",
  REFERENCE_2: "Viite 2",
  REFERENCE_INFORMATION: "Viitetiedot",
  REFERENCE_NUMBER1: "Viitenumero 1",
  REFERENCE_NUMBER2: "Viitenumero 2",
  REGION: "Alue",
  REGISTER: "Rekister\xF6i",
  REGISTER_A_PRODUCT_BY_PIN: "Rekister\xF6i tuote PIN-tunnuksen mukaan",
  REGISTER_A_PRODUCT_TO_ADD: "Rekister\xF6i takuuj\xE4rjestelm\xE4\xE4n lis\xE4tt\xE4v\xE4 tuote",
  REGISTER_ANOTHER_PRODUCT: "Rekister\xF6i toinen tuote",
  REGISTER_PRODUCT: "Rekister\xF6i tuote",
  REGISTER_PRODUCT_AND_REGISTER_ANOTHER: "Rekister\xF6i tuote ja rekister\xF6i toinen",
  REGISTERED: "Rekister\xF6ity",
  REGISTRATION: "Rekister\xF6inti",
  REGISTRATION_DATE: "Rekister\xF6intip\xE4iv\xE4m\xE4\xE4r\xE4",
  REGISTRATION_DATES: "Rekister\xF6intip\xE4iv\xE4m\xE4\xE4r\xE4t",
  REGISTRATION_FORM: "Rekister\xF6intilomake",
  REGISTRATION_HISTORY: "Rekister\xF6intihistoria",
  REGISTRATION_NOT_ALLOWED: "Rekister\xF6inti ei ole sallittu t\xE4lle tuotteelle",
  REGISTRATION_REVIEW: "Rekister\xF6innin tarkistus",
  REGISTRATION_REVIEW_TAB: "Rekister\xF6innin tarkistus ({count})",
  REGISTRATION_STATUS: "Rekister\xF6innin tila",
  REGISTRATION_STATUS_CANNOT_BE_NEW: "Rekister\xF6innin tila ei voi olla uusi",
  REGISTRATION_STATUS_REQUIRED: "Rekister\xF6innin tila vaaditaan",
  REGISTRATION_SUCCESS: "Rekister\xF6inti onnistui",
  REGISTRATION_TYPE: "Rekister\xF6intityyppi",
  REGISTRATION_TYPE_CANNOT_BE_NEW: "Rekister\xF6intityyppi ei voi olla uusi",
  REGISTRATION_TYPE_REQUIRED: "Rekister\xF6intityyppi vaaditaan",
  REGISTRATION_UPDATED_SUCCESSFULLY: "Rekister\xF6inti p\xE4ivitettiin onnistuneesti",
  REGISTRATIONS_REVIEW: "Rekister\xF6intien tarkistus",
  REIMBURSED: "Korvattu",
  REIMBURSED_AMOUNT: "Hyvitetty summa",
  REIMBURSED_PERCENTAGE: "Korvattu prosenttiosuus",
  REIMBURSED_PERCENTAGE_INDICATOR: "Korvatun prosenttiosuuden ilmaisin",
  REIMBURSEMENT_DETAILS: "Korvauksen tiedot",
  REIMBURSEMENT_PERCENTAGE: "Korvausprosentti",
  REIMBURSEMENT_SUMMARY: "Korvausten yhteenveto",
  REJECT: "Hylk\xE4\xE4",
  REJECT_LABOR_RATE: "Hylk\xE4\xE4 ty\xF6m\xE4\xE4r\xE4",
  REJECT_SPECIAL_ALLOWANCE_CLAIM: "Hylk\xE4\xE4 erikoiskorvausanomus",
  REJECTED: "Hyl\xE4tty",
  REJECTED_APPEAL: "Hyl\xE4tty anomus",
  RELATIONSHIP: "Suhde",
  RELATIONSHIP_IS_REQUIRED: "Suhde on pakollinen",
  REMOVE_FILTER: "Poista suodatin",
  REMOVE_FROM_AUDIT: "Poista valvonnasta",
  REMOVE_LAYOUT: "Poista asettelu",
  RENTAL_PINS: "Vuokrauksen PIN-koodit",
  REPAIR_DATE: "Korjausp\xE4iv\xE4m\xE4\xE4r\xE4",
  REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: "Korjausp\xE4iv\xE4m\xE4\xE4r\xE4 ei voi olla ennen virhep\xE4iv\xE4\xE4",
  REPAIR_NUMBER: "Korjausnumero",
  REPAIR_NUMBER_IS_REQUIRED: "Korjausnumero vaaditaan",
  REPAIR_REPLACE_INDICATOR: "Korjaa/vaihda ilmaisin",
  REPAIRED: "Korjattu",
  REPAIRED_DATE: "Korjausp\xE4iv\xE4m\xE4\xE4r\xE4",
  REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: "Korjausp\xE4iv\xE4m\xE4\xE4r\xE4 ei voi olla ennen ep\xE4onnistumisp\xE4iv\xE4m\xE4\xE4r\xE4\xE4",
  REPAIRED_DATE_IS_REQUIRED: "Korjausp\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  REPORT_DATE: "Raportin p\xE4iv\xE4m\xE4\xE4r\xE4",
  REPORT_NUMBER: "Raportin numero",
  REPORTS: "Raportit",
  REQ_ADDL: "S\xE4\xE4d\xE4 luottoa",
  REQUEST_DATE: "Pyynn\xF6n p\xE4iv\xE4m\xE4\xE4r\xE4",
  REQUEST_DETAILS: "Pyynn\xF6n tiedot",
  REQUEST_DUPLICATE_PIN_PLATE: "Pyyd\xE4 PIN-kortin kaksoiskappaletta",
  REQUEST_FORM: "Pyynt\xF6lomake",
  REQUEST_PIP_CODE: "Pyyd\xE4 PIP-koodi",
  REQUEST_STATUS: "Pyynn\xF6n tila",
  REQUEST_SUBMITTED: "Pyynt\xF6 l\xE4hetetty",
  REQUEST_TYPE: "Pyynn\xF6n tyyppi",
  REQUEST_UPDATED_SUCCESSFULLY: "Pyynt\xF6 p\xE4ivitettiin onnistuneesti",
  REQUEST_WARRANTY_CLAIM_DEBIT: "Pyyd\xE4 takuuanomuksen veloitusta",
  REQUESTED: "Pyydetty",
  REQUESTED_BY: "Pyyt\xE4nyt",
  REQUESTED_DATE: "Pyydetty p\xE4iv\xE4m\xE4\xE4r\xE4",
  REQUESTED_DATES: "Pyydetyt p\xE4iv\xE4m\xE4\xE4r\xE4t",
  REQUESTED_DIAGNOSTIC_AMOUNT: "Pyydetty diagnostiikan summa",
  REQUESTED_DIAGNOSTIC_HOURS: "Pyydetyt diagnostiikkatunnit",
  REQUESTED_LABOR_AMOUNT: "Pyydetty ty\xF6summa",
  REQUESTED_LABOR_HOURS: "Pyydetyt ty\xF6tunnit",
  REQUESTED_OTHER_CREDITS: "Pyydetyt muut hyvitykset",
  REQUESTED_PARTS: "Pyydetyt osat",
  REQUESTED_REPAIR_AMOUNT: "Pyydetty korjaussumma",
  REQUESTED_REPAIR_HOURS: "Pyydetyt korjaustunnit",
  REQUESTED_TRAVEL_TOTAL: "Pyydetty matka yhteens\xE4",
  REQUESTER_TCSM: "Pyyt\xE4j\xE4 (TCSM)",
  REQUESTER_TCSM_REQUIRED: "Pyyt\xE4j\xE4(TCSM) vaaditaan",
  REQUIRED: "pakollinen",
  REQUIRED_CRITERIA: "Pakolliset ehdot",
  REQUIRED_ITEMS: "Pakolliset kohteet",
  RESEND_XML: "L\xE4het\xE4 XML uudelleen",
  RESET: "Palauta",
  RESPONDENT_INFORMATION: "Vastaajan tiedot",
  RESPONSIBILITY_OF: "Vastuu",
  RESPONSIBLE_ACCOUNT: "Vastaava tili",
  RESPONSIBLE_ACCOUNT_IS_REQUIRED: "Vastuutili on pakollinen",
  RESPONSIBLE_DEALER: "Vastuussa oleva j\xE4lleenmyyj\xE4",
  RET: "Paluu",
  RETAIL_INSTALL: "V\xE4hitt\xE4ismyynti/asennus",
  RETAIL_INSTALL_DATE: "V\xE4hitt\xE4ismyynnin/asennuksen p\xE4iv\xE4m\xE4\xE4r\xE4",
  RETAIL_INSTALL_IS_REQUIRED: "V\xE4hitt\xE4ismyynti/asennus on pakollinen",
  RETAILER_NAME: "V\xE4hitt\xE4ismyyj\xE4n nimi",
  RETAILER_NAME_IS_REQUIRED: "V\xE4hitt\xE4ismyyj\xE4n nimi vaaditaan",
  RETRY: "yrit\xE4 uudelleen",
  RETURN: "Paluu",
  RETURN_LABOR_RATE: "Palautusty\xF6m\xE4\xE4r\xE4",
  RETURN_REQUEST: "Palautuspyynt\xF6",
  RETURN_SPECIAL_ALLOWANCE_CLAIM: "Erikoiskorvausanomus",
  RETURN_STATUS: "Palautustila",
  RETURNED: "Palautettu",
  RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: "Palautusp\xE4iv\xE4m\xE4\xE4r\xE4 ei voi olla ennen toimitusp\xE4iv\xE4\xE4",
  RETURNED_DATE_IS_REQUIRED: "Palautusp\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  REVIEW_DEALER_RECOMMENDATIONS: "Haluatko varmasti merkit\xE4 neulan tarkistettavaksi?",
  REVISE: "Muuta",
  REVISED: "Tarkistettu",
  ROLLING_12_CREDIT_AMOUNT: "Vieriv\xE4 12 kredit-summa",
  ROLLING_12_MONTHS: "12 kuukautta",
  RUN_REPORT: "Suorita raportti",
  RUSSIAN: "ven\xE4j\xE4",
  SAP_DOWN_WARNING: "Takuuj\xE4rjestelm\xE4n toiminta on rajoittunut. Pyrimme korjaamaan asian mahdollisimman nopeasti. Tarkista j\xE4rjestelm\xE4n k\xE4ytett\xE4vyys p\xE4ivitt\xE4m\xE4ll\xE4 selain.",
  SAVE: "Tallenna",
  SAVE_AS_DRAFT: "Tallenna luonnoksena",
  SAVE_AS_NEW_LAYOUT: "Tallenna uutena asetteluna",
  SAVE_AUDIT: "Tallenna seuranta",
  SAVE_CHANGES: "Tallenna muutokset",
  SAVE_TO_VALIDATE: "Tallenna vahvistettavaksi",
  SAVE_VALD: "Tallenna ja vahvista",
  SAVE_VALIDATE: "Tallenna ja vahvista",
  SEARCH: "Etsi",
  SEARCH_BOX_PLACEHOLDER: "Anna PIN, sarjanumero, takuuhakemuksen numero, DTAC-tapaus tai asiakkaan nimi",
  SEARCH_BY_CLAIM_TYPE: "Anna koko anomuksen tyyppi",
  SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: "anomushaun on oltava koko v\xE4itetyypin mukainen, 4-9 merkki\xE4",
  SEARCH_BY_FAILURE_PART_NUMBER: "Anna vikakoodin koko numero",
  SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: "anomushaun on oltava osanumeron t\xE4ysi virhe, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  SEARCH_BY_WORK_ORDER: "Anna ty\xF6tilaus, v\xE4hint\xE4\xE4n 2 merkki\xE4",
  SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: "Ty\xF6tilaushaussa on oltava v\xE4hint\xE4\xE4n kaksi merkki\xE4",
  SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: "Anna koko takuuhakemuksen numero",
  SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: "anomushaun on oltava koko anomusnumeron tasolla 4-9 merkki\xE4",
  SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: "Anna koko osan sarjanumero",
  SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: "Komponenttihaun on oltava t\xE4ydellinen sarjanumero, v\xE4hint\xE4\xE4n 1 merkki",
  SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: "Anna PIN",
  SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: "Anna koko mallinumero",
  SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: "Mallihaun on oltava t\xE4ydellinen mallinumero, 3-12 merkki\xE4",
  SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: "Anna PIN-koodi, v\xE4hint\xE4\xE4n 6 merkki\xE4",
  SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: "PIN-haussa on oltava 6-17 merkki\xE4",
  SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: "Anna PIP-numero, v\xE4hint\xE4\xE4n 4 merkki\xE4",
  SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: "PIP-haussa on oltava 4-12 merkki\xE4",
  SEARCH_RESULTS_TAB: "Hakutulokset ({count})",
  SECOND_SHIP_TO_LOCATION: "Toinen toimituspaikka",
  SELECT: "Valitse",
  SELECT_A_RANGE: "Valitse alue",
  SELECT_ALL: "Valitse kaikki",
  SELECT_AUTO_SUBMIT: "Valitse Automaattinen l\xE4hetys",
  SELECT_BRANCH: "Valitse haara",
  SELECT_CLAIM_TYPE: "Valitse takuuhakemuksen tyyppi",
  SELECT_CLAIMS: "Valitse takuuhakemukset",
  SELECT_CLAIMS_WITHIN_DATE_RANGE: "Valitse takuuhakemukset p\xE4iv\xE4m\xE4\xE4r\xE4v\xE4lill\xE4",
  SELECT_COLUMNS: "Valitse sarakkeet",
  SELECT_COUNTRY: "Valitse maa",
  SELECT_CSV_SEPARATOR: "Valitse CSV-erotin",
  SELECT_DATE_FORMAT: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4n muoto",
  SELECT_DEALERS_AND_STATUS: "Valitse j\xE4lleenmyyj\xE4t ja tila",
  SELECT_DECIMAL_FORMAT: "Valitse desimaalimuoto",
  SELECT_DISPLAY_FORMAT: "Valitse n\xE4ytt\xF6muoto",
  SELECT_FACTORY: "Valitse tehdas",
  SELECT_LANGUAGE: "Valitse kieli",
  SELECT_LAYOUT: "Valitse asettelu",
  SELECT_NEW_CLAIMS: "Valitse uudet takuuhakemukset",
  SELECT_PIP_CODE: "Valitse PIP-koodi",
  SELECT_PLAN_NAMES: "Valitse suunnitelman nimet",
  SELECT_SERVICE_INTERVAL_TYPES: "Valitse huoltov\xE4lityypit",
  SELECT_SORT_BY: "Valitse lajitteluperuste",
  SELECT_SORT_DIRECTION: "Valitse lajittelusuunta",
  SELECT_STATE: "Valitse tila",
  SELECT_STATUS: "Valitse tila",
  SELECT_TERRITORY: "Valitse alue",
  SELECT_THEME: "Valitse teema",
  SELECT_TIME_ZONE: "Valitse aikavy\xF6hyke",
  SELECT_VALUES_TO_APPROVE: "Valitse Hyv\xE4ksytt\xE4v\xE4t arvot",
  SELECTED_COLUMNS: "Valitut sarakkeet",
  SELECTED_FOR_AUDIT: "Valittu tarkastusta varten",
  SELECTED_FOR_AUDIT_VSR: "Katso DTAC-ratkaisusta 221475 t\xE4m\xE4n v\xE4itteen edellytt\xE4m\xE4t tarkistusasiakirjat ja -liitteet",
  SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: "Useiden tilien ja takuutyyppien valitseminen vaikuttaa suorituskykyyn",
  SEND: "L\xE4het\xE4",
  SERIAL_NUMBER: "Sarjanumero",
  SERIAL_NUMBER_INVOICE_NUMBER: "Sarjanumero / laskun numero",
  SERVER_TOOK_TOO_LONG_TO_REPLY: "Palvelin vastasi liian kauan, ja pyynt\xF6 on peruutettu. Yrit\xE4 tarkemmin tai yrit\xE4 my\xF6hemmin uudelleen.",
  SERVICE_DATE_IS_REQUIRED: "Huoltop\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  SERVICE_INTERVAL: "Huoltov\xE4li",
  SERVICE_INTERVAL_BEGIN_DATE: "Huoltov\xE4lin aloitusp\xE4iv\xE4m\xE4\xE4r\xE4",
  SERVICE_INTERVAL_END_DATE: "Huoltov\xE4lin p\xE4\xE4ttymisp\xE4iv\xE4",
  SERVICE_INTERVAL_IS_REQUIRED: "Huoltov\xE4li on pakollinen",
  SERVICE_INTERVAL_NUMBER: "Huoltov\xE4lin numero",
  SERVICE_INTERVAL_STATUS: "Huoltov\xE4lin tila",
  SERVICE_INTERVAL_TYPE: "Huoltov\xE4lin tyyppi",
  SERVICE_INTERVAL_TYPES: "Huoltov\xE4lityypit",
  SERVICE_PART: "Huolto-osa",
  SERVICE_UNAVAILABLE: "Palvelu ei ole k\xE4ytett\xE4viss\xE4",
  SERVICED: "Huollettu",
  SERVICED_DATE_IS_REQUIRED: "Huoltop\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  SERVICED_IS_REQUIRED: "Huolto on tarpeen.",
  SET_AS_DEFAULT: "Aseta oletukseksi",
  SETTINGS: "Omat asetukset",
  SETTLED: "Selvitetty",
  SETTLEMENT_NO_REGISTRATION: "Tilitys, ei rekister\xF6inti\xE4",
  SETUP: "Asetukset",
  SETUP_DATE_IS_REQUIRED: "Asetusp\xE4iv\xE4m\xE4\xE4r\xE4 on pakollinen",
  SETUP_IS_REQUIRED: "Asetukset ovat pakollisia",
  SGST_UTGST: "SGST/UTGST",
  SHIP_TO: "Toimitusosoite",
  SHIPPED: "L\xE4hetetty",
  SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: "L\xE4hetystiedot/erityisohjeet",
  SHIPPING_INSTRUCTIONS: "Toimitusohjeet",
  SHORT_TEXT: "Lyhyt teksti",
  SHORT_TEXT_IS_REQUIRED: "Lyhyt teksti vaaditaan",
  SHOW_ALL: "N\xE4yt\xE4 kaikki ({count})",
  SHOW_EXCLUDED: "N\xE4yt\xE4 ohitetut",
  SHOW_MORE: "N\xE4yt\xE4 lis\xE4\xE4",
  SHOW_MORE_GROUPS: "N\xE4yt\xE4 {countToDisplay} muuta {count, monikko, yksi {group} muu {group}}",
  SHOW_RED_IF_LESS_THAN: "N\xE4yt\xE4 punainen, jos pienempi kuin",
  SHOW_REIMBURSED_AMOUNT: "N\xE4yt\xE4 hyvitetty summa",
  SHOW_REIMBURSED_PERCENTAGE: "N\xE4yt\xE4 hyvitetty prosentti",
  SHOW_YELLOW_IF_LESS_THAN: "N\xE4yt\xE4 keltainen, jos pienempi kuin",
  SIGN_IN_REQUIRED: "Kirjaudu sis\xE4\xE4n",
  SIGN_OUT: "Kirjaudu ulos",
  SKIP_AUDIT: "Ohita seuranta",
  SKIP_AUDIT_SUCCESS: "Tarkastus on ohitettu, ja m\xE4\xE4r\xE4p\xE4iv\xE4 on nyt tulevaisuudessa.",
  SOME_PARTS_RETURNED: "Joitakin osia palautettu",
  SORT_BY: "Lajitteluperuste",
  SPANISH: "espanja",
  SPECIAL_ALLOWANCE: "Erikoisavustus",
  SPECIAL_ALLOWANCE_CALCULATION: "Erikoisavustuksen laskenta",
  SPECIAL_ALLOWANCE_CLAIM: "Erikoiskorvausanomus",
  SPECIAL_ALLOWANCE_CLAIM_STATUS: "Erikoiskorvausanomuksen tila",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: "Erikoiskorvausanomuksen tila",
  SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: "Erikoiskorvausanomuksen tila p\xE4ivitetty",
  SPECIAL_ALLOWANCE_CLAIM_WITH_ID: "Erikoiskorvausanomus - {claimNumber}",
  SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: "Erikoiskorvausanomukset ({count})",
  SPECIAL_ALLOWANCE_CONTRIBUTIONS: "Erikoisavustukset",
  SPECIAL_ALLOWANCE_DESCRIPTION: "Erikoisavustuksen kuvaus",
  SPECIAL_ALLOWANCE_TYPE: "Erikoisavustuksen tyyppi",
  SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: "Erikoisavustuksen tyyppi vaaditaan",
  SPECIAL_INSTRUCTIONS: "Erityisohjeet",
  SPG: "SPG",
  SPGS: "SPG:t",
  STANDARD_VIEW: "Vakion\xE4kym\xE4",
  START_AMOUNT_OF_USE: "Aloitusm\xE4\xE4r\xE4",
  STARTS: "Alkaa",
  STARTS_WITH: "Alkaa",
  STATE: "Osavaltio",
  STATE_PROVINCE: "Osavaltio/provinssi",
  STATE_PROVINCE_REQUIRED: "Vaadittu osavaltio/provinssi",
  STATUS: "Tila",
  STATUS_CHANGE_REQUEST: "Tilamuutospyynt\xF6",
  STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: "Tilamuutospyynn\xF6n luonti onnistui",
  STATUS_FOR: "Tila: {pin}",
  STATUS_INDICATOR: "Tilailmaisin",
  STATUS_REASON: "Tilan syy",
  STOLEN_DATE: "Varastettu p\xE4iv\xE4m\xE4\xE4r\xE4",
  STORE: "Myym\xE4l\xE4",
  STORE_IS_REQUIRED: "Myym\xE4l\xE4 on pakollinen",
  STORE_NUMBER_IS_REQUIRED: "Myym\xE4l\xE4n numero on pakollinen",
  STREET_1: "Katuosoite 1",
  STREET_2: "Katuosoite 2",
  SUB: "L\xE4het\xE4",
  SUB_CLAIM_TYPE: "Alianomuksen tyyppi",
  SUB_TYPE: "Alityyppi",
  SUBMISSION_DATE: "L\xE4hetysp\xE4iv\xE4m\xE4\xE4r\xE4",
  SUBMIT: "L\xE4het\xE4",
  SUBMIT_AUDIT: "L\xE4het\xE4 seuranta",
  SUBMIT_AUDIT_FOR: "L\xE4het\xE4 {dealer}-seuranta",
  SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "L\xE4het\xE4 {claimNumber} t\xE4ysimittainen veloitusanomus",
  SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "L\xE4het\xE4 osaveloitusanomus mallille {claimNumber}",
  SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: "L\xE4het\xE4 prosentin debet-vaatimus kohteelle {claimNumber}",
  SUBMIT_REQUEST: "L\xE4het\xE4 pyynt\xF6",
  SUBMITTED: "L\xE4hetetty",
  SUBMITTED_AVAILABLE_TO_EDIT: "L\xE4hetetty (muokattava)",
  SUCCESS: "Onnistui",
  SUCCESS_MESSAGE_TITLE: "Toiminto onnistui:",
  SUCCESS_MESSAGES_TITLE: "Useita toimintoja onnistui:",
  SUPPLIER_WARRANTY: "Toimittajan takuu",
  SURVEY_QUESTIONS: "Kyselykysymykset",
  SUSPENDED: "Keskeytetty",
  SWEDISH: "Ruotsi",
  SYSTEM_SELECTED_CLAIMS: "J\xE4rjestelm\xE4n valitsemat v\xE4itteet",
  SYSTEM_SELECTED_CLAIMS_WITH_COUNT: "J\xE4rjestelm\xE4n valitsemat v\xE4itteet ({count})",
  TABM: "TABM",
  TAX: "Vero",
  TCSM: "TCSM",
  TECH_ID: "Tekniikan tunnus",
  TERMINATED: "P\xE4\xE4tetty",
  TERMINATES: "P\xE4\xE4ttyy",
  TERRITORY: "Alue",
  TEST: "Testi",
  TEST_RESULTS_CODE: "Testitulosten koodi",
  THEME: "Teema",
  TIME_LIMIT: "Aikaraja",
  TIME_ZONE: "Aikavy\xF6hyke",
  TITLE: "Otsikko",
  TITLE_IS_REQUIRED: "Otsikko on pakollinen",
  TO: "Vastaanottaja",
  TODAY: "T\xE4n\xE4\xE4n",
  TOO_MANY_RESULTS: "Pyynt\xF6si palautti liian monta tulosta. Tarkenna hakuehtoja ja yrit\xE4 uudelleen.",
  TOTAL: "Yhteens\xE4",
  TOTAL_AMOUNT: "Kokonaissumma",
  TOTAL_APPROVED: "Hyv\xE4ksytty yhteens\xE4",
  TOTAL_APPROVED_CLAIM_VALUE: "Hyv\xE4ksytyn anomuksen kokonaisarvo",
  TOTAL_APPROVED_INCLUDING_TAXES: "Hyv\xE4ksytty yhteens\xE4, sis\xE4lt\xE4\xE4 verot",
  TOTAL_APPROVED_WITHOUT_ADDITIVES: "Hyv\xE4ksytty yhteens\xE4 ilman lisi\xE4",
  TOTAL_CONTRIBUTION: "Kokonaisosuus",
  TOTAL_REIMBURSED: "Hyvitetty yhteens\xE4",
  TOTAL_REIMBURSED_WITH_CURRENCY: "Hyvitetty yhteens\xE4 ({valuutta})",
  TOTAL_REQUESTED: "Pyydetty yhteens\xE4",
  TOTAL_REQUESTED_CLAIM_VALUE: "Pyydetyn anomuksen kokonaisarvo",
  TOTAL_UNPAID: "Maksamattomat yhteens\xE4",
  TRACKING_NUMBER: "Seurantanumero",
  TRANSFER: "Siirto",
  TRANSFER_APPROVALS: "Siirr\xE4 hyv\xE4ksynn\xE4t",
  TRANSFER_APPROVALS_TAB: "Siirr\xE4 hyv\xE4ksynn\xE4t ({count})",
  TRANSFER_CREATED: "Siirto luotu",
  TRANSFER_DEALER_RECOMMENDATIONS: "Haluatko varmasti siirt\xE4\xE4 neulan toiselle v\xE4litt\xE4j\xE4lle?",
  TRANSFER_UPDATED_SUCCESSFULLY: "Siirto p\xE4ivitettiin",
  TRANSFERS: "Siirrot",
  TRAVEL: "Matka",
  TURKISH: "turkki",
  TWO_PERCENT_WITHHOLD_VALUE: "Pid\xE4tysarvo 2 %",
  TYPE: "Tyyppi",
  TYPES: "Tyypit",
  UNABLE_TO_CONTACT_THE_SERVER: "Palvelimeen ei saada yhteytt\xE4",
  UNABLE_TO_LOAD_CUSTOMER_DETAILS: "Asiakkaan tietoja ei voi ladata",
  UNDO: "Kumoa",
  UNDO_REGISTRATION: "Kumoa rekister\xF6inti",
  UNDO_REGISTRATION_SUCCESSFULL: "Rekister\xF6innin kumoaminen onnistui",
  UNIT: "Yksikk\xF6",
  UNIT_1: "Yksikk\xF6 1",
  UNIT_2: "Yksikk\xF6 2",
  UNIT_3: "Yksikk\xF6 3",
  UNIT_OF_MEASURE: "Mittayksikk\xF6",
  UNPAID_LABOR: "Palkaton ty\xF6",
  UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: "Unpaid Labor Additives (Maksamattomat t\xF6iden lis\xE4korvaukset - PIP-korjaukset pois lukien)",
  UNPAID_LABOR_ADDITIVES_PIPS: "Unpaid Labor Additives - PIPs (Maksamattomat t\xF6iden lis\xE4korvaukset - PIP-korjaukset)",
  UNPAID_OTHER_CREDITS: "Maksamattomat muut hyvitykset",
  UNPAID_PARTS: "Maksamattomat osat",
  UNPAID_PARTS_ADDITIVE: "Maksamattomien osien lis\xE4",
  UNPAID_TRAVEL: "Maksamaton matka",
  UNSUB: "Peruuta l\xE4hetys",
  UNSUBMIT_CLAIM: "Peruuta anomus",
  UPDATE_CUSTOMER_INFORMATION: "P\xE4ivit\xE4 asiakastiedot",
  UPDATE_LABOR_RATES: "P\xE4ivit\xE4 ty\xF6asteet",
  UPDATE_LAYOUT: "P\xE4ivit\xE4 asettelu",
  UPDATE_MACHINE_STATUS: "P\xE4ivit\xE4 koneen tila",
  UPDATE_MACHINE_STATUS_HISTORY: "P\xE4ivit\xE4 koneen tilahistoria",
  UPDATE_REGISTRATION: "P\xE4ivit\xE4 rekister\xF6inti",
  UPDATE_SELECTED: "P\xE4ivit\xE4 valitut",
  UPDATED: "P\xE4ivitetty",
  UPDATED_BY: "P\xE4ivitt\xE4nyt",
  UPLOAD_DOCUMENT: "Lataa tiedosto",
  UPTIME_ASSURANCE: "K\xE4ytt\xF6ajan valvonta",
  USEFUL_LINKS: "Hy\xF6dyllisi\xE4 linkkej\xE4",
  USER: "k\xE4ytt\xE4j\xE4",
  USER_PREFERENCES_UPDATED: "K\xE4ytt\xE4j\xE4asetukset p\xE4ivitetty",
  USER_SELECTED: "K\xE4ytt\xE4j\xE4 valittu",
  USER_SELECTED_CLAIMS_WITH_COUNT: "K\xE4ytt\xE4j\xE4n valitsemat v\xE4itteet ({count})",
  USERS_INFORMATION: "K\xE4ytt\xE4jien tiedot",
  VALIDATE: "Vahvista",
  VALIDATE_CLAIM: "Vahvista anomus",
  VALUE: "Arvo",
  VALUE_OF_REPAIR: "Korjausarvo",
  VIEW_CLAIM: "N\xE4yt\xE4 anomus",
  VIEW_DETAILS: "N\xE4yt\xE4 tiedot",
  VIEW_OPEN_PIPS: "N\xE4yt\xE4 avoimet PIP-ohjelmat",
  VIEW_PIP: "N\xE4yt\xE4 PIP",
  VIEW_PRODUCTS: "N\xE4yt\xE4 tuotteet",
  VIEW_PRODUCTS_AND_UPDATE_INFO: "N\xE4yt\xE4 tuotteet ja p\xE4ivit\xE4 tiedot",
  VIEW_UPDATE: "N\xE4yt\xE4/p\xE4ivit\xE4",
  VSR_MESSAGES: "VSR-viestit",
  WAITING_FOR_DLR_INV: "Odotetaan J\xE4lleenmyyj\xE4n Laskua",
  WAITING_FOR_INVOICE: "Odotetaan laskua ({count})",
  WAITING_SINCE: "Odotetaan",
  WARNING_MESSAGE_TITLE: "Varoitus l\xE4hetettiin:",
  WARNING_MESSAGES: "Varoitusviestit",
  WARNING_MESSAGES_TITLE: "Useita varoituksia l\xE4hetettiin:",
  WARRANTY: "Takuu",
  WARRANTY_ADMIN: "Takuun j\xE4rjestelm\xE4nvalvoja",
  WARRANTY_CLAIM_TYPE: "Takuuvaatimuksen tyyppi",
  WARRANTY_COVERAGE: "Takuun kattavuus",
  WARRANTY_EXPIRATION: "Takuun vanhentuminen",
  WARRANTY_TYPE: "Takuun tyyppi",
  WARRANTY_TYPES: "Takuutyypit",
  WEAR_PARTS: "Kulutusosat",
  WEAR_PARTS_COVERAGE: "Kulutusosat",
  WELCOME: "Tervetuloa",
  WIP: "Ty\xF6 k\xE4ynniss\xE4",
  WITH_ADDITIVES: "Lisien kanssa",
  WITNESS_FIRST_NAME: "Todistajan etunimi",
  WITNESS_LAST_NAME: "Todistajan sukunimi",
  WORK_ORDER: "Ty\xF6j\xE4rjestys",
  WORK_ORDER_NUMBER: "Ty\xF6tilauksen numero",
  WORK_ORDER_ONE: "Ty\xF6tilaus 1",
  WORK_ORDER_ONE_IS_REQUIRED: "Ty\xF6tilaus 1 vaaditaan",
  WORK_ORDER_THREE: "Ty\xF6tilaus 3",
  WORK_ORDER_THREE_IS_REQUIRED: "Ty\xF6tilaus 3 vaaditaan",
  WORK_ORDER_TWO: "Ty\xF6tilaus 2",
  WORK_REPAIR_ORDER: "Ty\xF6korjaustilaus",
  YES: "KYLL\xC4",
  YES_LOWERCASE: "Kyll\xE4"
});